export const ProductsData = [
  {
    _index: "almanea_en_catalog_product_20240521_105137",
    _id: "10293",
    _score: null,
    _source: {
      1101: {
        value: 2,
      },
      short_description: [
        "<ul>\r\n<li>\r\n<p><strong>18W</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>10,000 mAh</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>Mobile Stand</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>High Speed</strong></p>\r\n</li>\r\n</ul>",
      ],
      image: ["/p/b/pb-wl02-bk.jpg"],
      option_text_brand: ["Aukey"],
      prices_with_tax: {
        discounted_price_to: "",
        original_price: 198.996001,
        price: 198.996001,
        is_count_down: false,
        discounted_price_from: "",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=BS9DK3O]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="BS9DK3O"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>Power Delivery Technology</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10293",
      eligible_for_tamara: [true],
      url_key: [
        "aukey-stand-wireless-charge-pbank-18w-3-0-10-000-mah-black-p-6144211002",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/b/pb-wl02-bk.webp",
            width: 960,
            position: "1",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/b/pb-wl02-bk_2_.webp",
            width: 960,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7423,
            level: 3,
            name: "Mobiles & Tablets",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7428,
            level: 4,
            name: "Mobile Accessories",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7432,
            level: 5,
            name: "Power Banks",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7443,
            level: 3,
            name: "Cameras & Accessories",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7444,
            level: 2,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7463,
            level: 3,
            name: "categories home app2",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7467,
            level: 4,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7474,
            level: 3,
            name: "Recommended2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "Eid Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7502,
            level: 4,
            name: "Same day delivery",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7505,
            level: 4,
            name: "Electronics",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7507,
            level: 2,
            name: "Home Page",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7508,
            level: 3,
            name: "Electronics",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "Back To School Offers",
          is_parent: true,
        },
      },
      name: ["Aukey Stand Wireless Charge PBank 18W 3.0 10,000 mAh Black"],
      back_orders: 0,
      sku: "6144211002",
      stock: {
        is_in_stock: false,
        qty: 4,
      },
      rewrite_url:
        "aukey-stand-wireless-charge-pbank-18w-3-0-10-000-mah-black-p-6144211002",
    },
    sort: [2147483647],
  },
  {
    _index: "almanea_en_catalog_product_20240521_105137",
    _id: "10323",
    _score: null,
    _source: {
      1101: {
        value: 5,
      },
      short_description: [
        "<ul>\r\n<li>\r\n<p><strong>20W</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>10,000 mAh</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>High Speed</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>Power Delivery Technology</strong></p>\r\n</li>\r\n</ul>",
      ],
      image: ["/p/b/pb-y36s-bk.jpg"],
      option_text_brand: ["Aukey"],
      prices_with_tax: {
        discounted_price_to: "",
        original_price: 139.000501,
        price: 139.000501,
        is_count_down: false,
        discounted_price_from: "",
      },
      type_id: "simple",
      label: [],
      entity_id: "10323",
      eligible_for_tamara: [true],
      url_key: [
        "aukey-sprint-go-10-000-mah-power-bank-with-20w-pd-black-p-6144211009",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/b/pb-y36s-bk.webp",
            width: 1024,
            position: "1",
            url: null,
            height: 1024,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/b/pb-y36s-bk_2_.webp",
            width: 960,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7423,
            level: 3,
            name: "Mobiles & Tablets",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7428,
            level: 4,
            name: "Mobile Accessories",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7432,
            level: 5,
            name: "Power Banks",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7443,
            level: 3,
            name: "Cameras & Accessories",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7444,
            level: 2,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7463,
            level: 3,
            name: "categories home app2",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7467,
            level: 4,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7474,
            level: 3,
            name: "Recommended2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "Eid Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7502,
            level: 4,
            name: "Same day delivery",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7505,
            level: 4,
            name: "Electronics",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7507,
            level: 2,
            name: "Home Page",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7508,
            level: 3,
            name: "Electronics",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "Back To School Offers",
          is_parent: true,
        },
      },
      name: ["Aukey Sprint Go 10,000 mAh Power Bank With 20W PD - Black"],
      back_orders: 0,
      sku: "6144211009",
      stock: {
        is_in_stock: true,
        qty: 11,
      },
      rewrite_url:
        "aukey-sprint-go-10-000-mah-power-bank-with-20w-pd-black-p-6144211009",
    },
    sort: [2147483647],
  },
  {
    _index: "almanea_en_catalog_product_20240521_105137",
    _id: "10324",
    _score: null,
    _source: {
      1101: {
        value: 16949,
      },
      short_description: [
        "<ul>\r\n<li>\r\n<p><strong>20W</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>15,000 mAh</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>High Speed</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>Power Delivery Technology</strong></p>\r\n</li>\r\n</ul>",
      ],
      image: ["/p/b/pb-y39s-bk.jpg"],
      option_text_brand: ["Aukey"],
      prices_with_tax: {
        discounted_price_to: "",
        original_price: 158.999001,
        price: 158.999001,
        is_count_down: false,
        discounted_price_from: "",
      },
      type_id: "simple",
      label: [],
      entity_id: "10324",
      eligible_for_tamara: [true],
      url_key: [
        "aukey-sprint-go-15-000-mah-pd-20w-power-bank-usb-c-black-p-6144211010",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/b/pb-y39s-bk.webp",
            width: 960,
            position: "1",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/b/pb-y39s-bk_2_.webp",
            width: 960,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7423,
            level: 3,
            name: "Mobiles & Tablets",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7428,
            level: 4,
            name: "Mobile Accessories",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7432,
            level: 5,
            name: "Power Banks",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7443,
            level: 3,
            name: "Cameras & Accessories",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7444,
            level: 2,
            name: "Electronics ",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "Eid Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "Back To School Offers",
          is_parent: true,
        },
      },
      name: ["Aukey Sprint Go 15,000 mAh PD 20W Power Bank USB-C Black"],
      back_orders: 0,
      sku: "6144211010",
      stock: {
        is_in_stock: true,
        qty: 36000,
      },
      rewrite_url:
        "aukey-sprint-go-15-000-mah-pd-20w-power-bank-usb-c-black-p-6144211010",
    },
    sort: [2147483647],
  },
  {
    _index: "almanea_en_catalog_product_20240521_105137",
    _id: "10325",
    _score: null,
    _source: {
      1101: {
        value: 6,
      },
      short_description: [
        "<ul>\r\n<li>\r\n<p><strong>Magnetic</strong></p>\r\n<p> </p>\r\n</li>\r\n<li>\r\n<p><strong>Air Vent Holder</strong></p>\r\n</li>\r\n</ul>",
      ],
      image: ["/h/d/hd-c74-bk.jpg"],
      option_text_brand: ["Aukey"],
      prices_with_tax: {
        discounted_price_to: "",
        original_price: 58.995001,
        price: 58.995001,
        is_count_down: false,
        discounted_price_from: "",
      },
      type_id: "simple",
      label: [],
      entity_id: "10325",
      eligible_for_tamara: [true],
      url_key: [
        "aukey-super-magnetic-air-vent-car-phone-mount-c74-black-p-6144291006",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/h/d/hd-c74-bk.webp",
            width: 960,
            position: "1",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/h/d/hd-c74-bk_2_.webp",
            width: 960,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7423,
            level: 3,
            name: "Mobiles & Tablets",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7428,
            level: 4,
            name: "Mobile Accessories",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7442,
            level: 5,
            name: "Cradles",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7443,
            level: 3,
            name: "Cameras & Accessories",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7444,
            level: 2,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7463,
            level: 3,
            name: "categories home app2",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7467,
            level: 4,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7474,
            level: 3,
            name: "Recommended2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "Eid Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7502,
            level: 4,
            name: "Same day delivery",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7505,
            level: 4,
            name: "Electronics",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7507,
            level: 2,
            name: "Home Page",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7508,
            level: 3,
            name: "Electronics",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "Back To School Offers",
          is_parent: true,
        },
      },
      name: ["Aukey Super Magnetic Air Vent Car Phone Mount C74 Black"],
      back_orders: 0,
      sku: "6144291006",
      stock: {
        is_in_stock: true,
        qty: 11,
      },
      rewrite_url:
        "aukey-super-magnetic-air-vent-car-phone-mount-c74-black-p-6144291006",
    },
    sort: [2147483647],
  },
  {
    _index: "almanea_en_catalog_product_20240521_105137",
    _id: "10326",
    _score: null,
    _source: {
      1101: {
        value: 4,
      },
      short_description: [
        "<ul>\r\n<li>30W</li>\r\n<li>2 Port</li>\r\n<li>High Speed</li>\r\n<li>Power Delivery Technology</li>\r\n</ul>",
      ],
      image: ["/p/a/pa-f3s-bk.png"],
      option_text_brand: ["Aukey"],
      prices_with_tax: {
        discounted_price_to: "",
        original_price: 99.003501,
        price: 99.003501,
        is_count_down: false,
        discounted_price_from: "",
      },
      type_id: "simple",
      label: [],
      entity_id: "10326",
      eligible_for_tamara: [true],
      url_key: [
        "aukey-swift-32w-2-port-pd-wall-charger-pa-f3s-black-p-6144221011",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/p/a/pa-f3s-bk.webp",
            width: 690,
            position: "1",
            url: null,
            height: 557,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/a/pa-f3s-bk.webp",
            width: 970,
            position: "2",
            url: null,
            height: 600,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7423,
            level: 3,
            name: "Mobiles & Tablets",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7428,
            level: 4,
            name: "Mobile Accessories",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7431,
            level: 5,
            name: "Chargers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7443,
            level: 3,
            name: "Cameras & Accessories",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7444,
            level: 2,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7463,
            level: 3,
            name: "categories home app2",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7467,
            level: 4,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7474,
            level: 3,
            name: "Recommended2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "Eid Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7502,
            level: 4,
            name: "Same day delivery",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7505,
            level: 4,
            name: "Electronics",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7507,
            level: 2,
            name: "Home Page",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7508,
            level: 3,
            name: "Electronics",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "Back To School Offers",
          is_parent: true,
        },
      },
      name: ["Aukey Swift 32W 2-Port PD Wall Charger PA-F3S Black"],
      back_orders: 0,
      sku: "6144221011",
      stock: {
        is_in_stock: true,
        qty: 17,
      },
      rewrite_url:
        "aukey-swift-32w-2-port-pd-wall-charger-pa-f3s-black-p-6144221011",
    },
    sort: [2147483647],
  },
  {
    _index: "almanea_en_catalog_product_20240521_105137",
    _id: "10326",
    _score: null,
    _source: {
      1101: {
        value: 4,
      },
      short_description: [
        "<ul>\r\n<li>30W</li>\r\n<li>2 Port</li>\r\n<li>High Speed</li>\r\n<li>Power Delivery Technology</li>\r\n</ul>",
      ],
      image: ["/p/a/pa-f3s-bk.png"],
      option_text_brand: ["Aukey"],
      prices_with_tax: {
        discounted_price_to: "",
        original_price: 99.003501,
        price: 99.003501,
        is_count_down: false,
        discounted_price_from: "",
      },
      type_id: "simple",
      label: [],
      entity_id: "10326",
      eligible_for_tamara: [true],
      url_key: [
        "aukey-swift-32w-2-port-pd-wall-charger-pa-f3s-black-p-6144221011",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/p/a/pa-f3s-bk.webp",
            width: 690,
            position: "1",
            url: null,
            height: 557,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/a/pa-f3s-bk.webp",
            width: 970,
            position: "2",
            url: null,
            height: 600,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7423,
            level: 3,
            name: "Mobiles & Tablets",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7428,
            level: 4,
            name: "Mobile Accessories",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7431,
            level: 5,
            name: "Chargers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7443,
            level: 3,
            name: "Cameras & Accessories",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7444,
            level: 2,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7463,
            level: 3,
            name: "categories home app2",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7467,
            level: 4,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7474,
            level: 3,
            name: "Recommended2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "Eid Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7502,
            level: 4,
            name: "Same day delivery",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7505,
            level: 4,
            name: "Electronics",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7507,
            level: 2,
            name: "Home Page",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7508,
            level: 3,
            name: "Electronics",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "Back To School Offers",
          is_parent: true,
        },
      },
      name: ["Aukey Swift 32W 2-Port PD Wall Charger PA-F3S Black"],
      back_orders: 0,
      sku: "6144221011",
      stock: {
        is_in_stock: true,
        qty: 17,
      },
      rewrite_url:
        "aukey-swift-32w-2-port-pd-wall-charger-pa-f3s-black-p-6144221011",
    },
    sort: [2147483647],
  },
  {
    _index: "almanea_en_catalog_product_20240521_105137",
    _id: "10326",
    _score: null,
    _source: {
      1101: {
        value: 4,
      },
      short_description: [
        "<ul>\r\n<li>30W</li>\r\n<li>2 Port</li>\r\n<li>High Speed</li>\r\n<li>Power Delivery Technology</li>\r\n</ul>",
      ],
      image: ["/p/a/pa-f3s-bk.png"],
      option_text_brand: ["Aukey"],
      prices_with_tax: {
        discounted_price_to: "",
        original_price: 99.003501,
        price: 99.003501,
        is_count_down: false,
        discounted_price_from: "",
      },
      type_id: "simple",
      label: [],
      entity_id: "10326",
      eligible_for_tamara: [true],
      url_key: [
        "aukey-swift-32w-2-port-pd-wall-charger-pa-f3s-black-p-6144221011",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/p/a/pa-f3s-bk.webp",
            width: 690,
            position: "1",
            url: null,
            height: 557,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/p/a/pa-f3s-bk.webp",
            width: 970,
            position: "2",
            url: null,
            height: 600,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7423,
            level: 3,
            name: "Mobiles & Tablets",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7428,
            level: 4,
            name: "Mobile Accessories",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7431,
            level: 5,
            name: "Chargers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7443,
            level: 3,
            name: "Cameras & Accessories",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7444,
            level: 2,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7463,
            level: 3,
            name: "categories home app2",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7467,
            level: 4,
            name: "Electronics ",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7474,
            level: 3,
            name: "Recommended2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "Ramadan Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "Eid Offers",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7502,
            level: 4,
            name: "Same day delivery",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7505,
            level: 4,
            name: "Electronics",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7507,
            level: 2,
            name: "Home Page",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7508,
            level: 3,
            name: "Electronics",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "Back To School Offers",
          is_parent: true,
        },
      },
      name: ["Aukey Swift 32W 2-Port PD Wall Charger PA-F3S Black"],
      back_orders: 0,
      sku: "6144221011",
      stock: {
        is_in_stock: true,
        qty: 17,
      },
      rewrite_url:
        "aukey-swift-32w-2-port-pd-wall-charger-pa-f3s-black-p-6144221011",
    },
    sort: [2147483647],
  },
];

// these data is related to top ten pages

//! dish washers data

export const Washer1 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7674",
    _score: null,
    _source: {
      1101: {
        value: 1430,
      },
      short_description: [
        '<ul>\r\n<li><span style="color: #000000;">قفل للاطفال</span></li>\r\n<li><span style="color: #000000;">شاشة LED </span></li>\r\n<li><span style="color: #000000;">تأجيل بدا الغسيل </span></li>\r\n</ul>',
      ],
      image: ["/4/2/422a9887-bc32-4ea7-b65a-d23a22355fa2_1.png"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1798.945001,
        price: 1798.945001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=V6ASG8Y]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="V6ASG8Y"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li style="text-align: right;"><span style="color: #000000;">فلتر سهل التنظيف</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر إضافة الملح&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">اشعار انتهاء الغسيل </span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">يرامج متعددة للغسيل</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر مساعد الشطف&nbsp; </span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">خاصية نصف الحمولة&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">ارفف مرنة قابلة للتعديل&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">درجة حرارة المياة تصل إلى 70 درجة&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">السطح الداخلي استانلس استيل مقاوم للصدأ&nbsp;&nbsp;</span></li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "7674",
      eligible_for_tamara: [true],
      url_key: ["haam-dishwasher-14-unit-silver-hm14psdw18-p-1608121021"],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/4/2/422a9887-bc32-4ea7-b65a-d23a22355fa2_1.webp",
            width: 800,
            position: "22",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/0/b/0b897d84-d9d5-4b21-9308-8ef78bae7ce1_1.webp",
            width: 557,
            position: "23",
            url: null,
            height: 800,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 3 ارفف فضي 14 مكان 8 برامج HM14PSDW18"],
      back_orders: 0,
      sku: "1608121021",
      stock: {
        is_in_stock: true,
        qty: 1706,
      },
      rewrite_url: "haam-dishwasher-14-unit-silver-hm14psdw18-p-1608121021",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>3</strong> <strong>ارفف</strong> <strong>فضي</strong> <strong>14</strong> <strong>مكان</strong> <strong>8</strong> <strong>برامج</strong> <strong>HM14</strong><strong>PSDW</strong><strong>18</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10110",
    _score: null,
    _source: {
      1101: {
        value: 416,
      },
      short_description: [
        "<ul>\r\n<li>شاشة LED</li>\r\n<li>قفل للاطفال</li>\r\n<li>تأجيل بدا الغسيل</li>\r\n</ul>",
      ],
      image: ["/n/e/new_project_1__17_1.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1598.960001,
        price: 1598.960001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=VJDC8DT]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="VJDC8DT"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>\r\n<p style="text-align: right;">خاصية نصف الحمولة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الفتح التلقائي للباب بعد نهاية البرنامج</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الغسيل القوي للصحون </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>قفل للأطفال </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تسخين المياه حتي 70 درجة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تأخير بدء الغسيل </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر مساعد الشطف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر إضافة الملح </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>فلتر سهل التنظيف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الرف العلوي مرن قابل للتعديل </p>\r\n</li>\r\n<li style="text-align: right;">إشعار انتهاء البرنامج </li>\r\n<li style="text-align: right;">السطح الداخلي استانلس استيل</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10110",
      eligible_for_tamara: [true],
      url_key: [
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/n/e/new_project_1__17_1.webp",
            width: 1200,
            position: "3",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23"],
      back_orders: 0,
      sku: "1608122013",
      stock: {
        is_in_stock: true,
        qty: 501,
      },
      rewrite_url:
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>12</strong> <strong>مكان</strong> <strong>7</strong> <strong>برامج</strong> <strong>استيل</strong> <strong>HMDW1207</strong><strong>S</strong><strong>23</strong>",
      ],
    },
    sort: [5],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7676",
    _score: null,
    _source: {
      1101: {
        value: 82,
      },
      image: ["/b/e/be37c76e-05e6-4918-a2fb-e89b2da8dbcd.jpg"],
      option_text_brand: ["أريستون"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 3478.980001,
        price: 3478.980001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "7676",
      eligible_for_tamara: [true],
      url_key: [
        "ariston-dishwasher-14-places-7-programs-silver-lfc-3c26-w-x-60hz-p-1605622121",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/b/e/be37c76e-05e6-4918-a2fb-e89b2da8dbcd.webp",
            width: 400,
            position: "14",
            url: null,
            height: 300,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون اريستون 7 برامج فضي 14 مكان LFC 3C26 W X 60HZ"],
      back_orders: 0,
      sku: "1605622121",
      stock: {
        is_in_stock: true,
        qty: 95,
      },
      rewrite_url:
        "ariston-dishwasher-14-places-7-programs-silver-lfc-3c26-w-x-60hz-p-1605622121",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>اريستون</strong> <strong>7</strong> <strong>برامج</strong> <strong>فضي</strong> <strong>14</strong> <strong>مكان</strong> <strong>LFC</strong> <strong>3C</strong><strong>26</strong> <strong>W</strong> <strong>X</strong> <strong>60HZ</strong>",
      ],
    },
    sort: [-2147483648],
  },
  // 4th product is not exist
  // غسالة صحون اكسبير شاشة LED فضي 14 مكان 6 برامج DW1410SXP20
  // this data is not the real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7087",
    _score: null,
    _source: {
      1101: {
        value: 40,
      },
      image: ["/l/i/lic3c26c60hz_mtc-108528_1.jpg"],
      option_text_brand: ["أريستون"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 3928.975001,
        price: 3928.975001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "7087",
      eligible_for_tamara: [true],
      url_key: [
        "ariston-built-in-fully-integrated-dishwasher-6-programs-14-places-silver-lic-3c26-c-60h-p-1605622111",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/l/i/lic3c26c60hz_mtc-108528_1.webp",
            width: 1206,
            position: "1",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7379,
            level: 5,
            name: "مدمج",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون اريستون بلت ان 6 برامج فضى 14 مكان LIC 3C26 C 60H"],
      back_orders: 0,
      sku: "1605622111",
      stock: {
        is_in_stock: true,
        qty: 52,
      },
      rewrite_url:
        "ariston-built-in-fully-integrated-dishwasher-6-programs-14-places-silver-lic-3c26-c-60h-p-1605622111",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>اريستون</strong> بلت ان <strong>6</strong> <strong>برامج</strong> <strong>فضى</strong> <strong>14</strong> <strong>مكان</strong> <strong>LIC</strong> <strong>3C</strong><strong>26</strong> <strong>C</strong> <strong>60</strong><strong>H</strong>",
      ],
    },
    sort: [-2147483648],
  },
];

export const Washer2 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9273",
    _score: null,
    _source: {
      1101: {
        value: 55,
      },
      image: ["/0/1/01df2f38-1c34-4d30-81e6-b7562ea44909_1.jpg"],
      option_text_brand: ["فريجيدير"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 2100.015001,
        price: 2100.015001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9273",
      eligible_for_tamara: [true],
      url_key: [
        "frigidaire-dishwasher-12-places-6-program-white-fdfe12ffgcwd-p-1614300010",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/0/1/01df2f38-1c34-4d30-81e6-b7562ea44909_1.webp",
            width: 400,
            position: "2",
            url: null,
            height: 300,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون فريجدير 12 مكان 6 برامج ابيض FDFE12FFGCWD"],
      back_orders: 0,
      sku: "1614300010",
      stock: {
        is_in_stock: true,
        qty: 67,
      },
      rewrite_url:
        "frigidaire-dishwasher-12-places-6-program-white-fdfe12ffgcwd-p-1614300010",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>فريجدير</strong> <strong>12</strong> <strong>مكان</strong> <strong>6</strong> <strong>برامج</strong> <strong>ابيض</strong> <strong>FDFE12</strong><strong>FFGCWD</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "8338",
    _score: null,
    _source: {
      1101: {
        value: 173,
      },
      short_description: [
        "<ul>\r\n<li>قفل للأطفال </li>\r\n<li>تأخير بدء الغسيل </li>\r\n<li>فلتر سهل التنظيف </li>\r\n</ul>",
      ],
      image: ["/7/f/7f99a476-56b7-46f5-8842-30576afbfb0d.jpg"],
      option_text_brand: ["اكسبير"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1598.960001,
        price: 1598.960001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=QBGYFF4]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="QBGYFF4"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر إضافة الملح&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر مساعد الشطف&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">إشعار انتهاء البرنامج </span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">أرفف مرنة قابلة للتعديل&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">السطح الداخلي استانلس استيل&nbsp;&nbsp;</span></li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "8338",
      eligible_for_tamara: [true],
      url_key: [
        "xper-dishwasher-14-places-6-programs-silver-dw1400sxp20-p-1609120010",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/7/f/7f99a476-56b7-46f5-8842-30576afbfb0d.webp",
            width: 400,
            position: "11",
            url: null,
            height: 300,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون اكسبير فضي 14 مكان 6 برامج DW1400SXP20"],
      back_orders: 0,
      sku: "1609120010",
      stock: {
        is_in_stock: true,
        qty: 197,
      },
      rewrite_url:
        "xper-dishwasher-14-places-6-programs-silver-dw1400sxp20-p-1609120010",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>اكسبير</strong> <strong>فضي</strong> <strong>14</strong> <strong>مكان</strong> <strong>6</strong> <strong>برامج</strong> <strong>DW1400</strong><strong>SXP</strong><strong>20</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10110",
    _score: null,
    _source: {
      1101: {
        value: 416,
      },
      short_description: [
        "<ul>\r\n<li>شاشة LED</li>\r\n<li>قفل للاطفال</li>\r\n<li>تأجيل بدا الغسيل</li>\r\n</ul>",
      ],
      image: ["/n/e/new_project_1__17_1.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1598.960001,
        price: 1598.960001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=VJDC8DT]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="VJDC8DT"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>\r\n<p style="text-align: right;">خاصية نصف الحمولة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الفتح التلقائي للباب بعد نهاية البرنامج</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الغسيل القوي للصحون </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>قفل للأطفال </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تسخين المياه حتي 70 درجة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تأخير بدء الغسيل </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر مساعد الشطف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر إضافة الملح </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>فلتر سهل التنظيف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الرف العلوي مرن قابل للتعديل </p>\r\n</li>\r\n<li style="text-align: right;">إشعار انتهاء البرنامج </li>\r\n<li style="text-align: right;">السطح الداخلي استانلس استيل</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10110",
      eligible_for_tamara: [true],
      url_key: [
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/n/e/new_project_1__17_1.webp",
            width: 1200,
            position: "3",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23"],
      back_orders: 0,
      sku: "1608122013",
      stock: {
        is_in_stock: true,
        qty: 501,
      },
      rewrite_url:
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>12</strong> <strong>مكان</strong> <strong>7</strong> <strong>برامج</strong> <strong>استيل</strong> <strong>HMDW1207</strong><strong>S</strong><strong>23</strong>",
      ],
    },
    sort: [5],
  },
];

export const Washer3 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10110",
    _score: null,
    _source: {
      1101: {
        value: 416,
      },
      short_description: [
        "<ul>\r\n<li>شاشة LED</li>\r\n<li>قفل للاطفال</li>\r\n<li>تأجيل بدا الغسيل</li>\r\n</ul>",
      ],
      image: ["/n/e/new_project_1__17_1.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1598.960001,
        price: 1598.960001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=VJDC8DT]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="VJDC8DT"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>\r\n<p style="text-align: right;">خاصية نصف الحمولة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الفتح التلقائي للباب بعد نهاية البرنامج</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الغسيل القوي للصحون </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>قفل للأطفال </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تسخين المياه حتي 70 درجة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تأخير بدء الغسيل </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر مساعد الشطف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر إضافة الملح </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>فلتر سهل التنظيف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الرف العلوي مرن قابل للتعديل </p>\r\n</li>\r\n<li style="text-align: right;">إشعار انتهاء البرنامج </li>\r\n<li style="text-align: right;">السطح الداخلي استانلس استيل</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10110",
      eligible_for_tamara: [true],
      url_key: [
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/n/e/new_project_1__17_1.webp",
            width: 1200,
            position: "3",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23"],
      back_orders: 0,
      sku: "1608122013",
      stock: {
        is_in_stock: true,
        qty: 501,
      },
      rewrite_url:
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>12</strong> <strong>مكان</strong> <strong>7</strong> <strong>برامج</strong> <strong>استيل</strong> <strong>HMDW1207</strong><strong>S</strong><strong>23</strong>",
      ],
    },
    sort: [5],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10109",
    _score: null,
    _source: {
      1101: {
        value: 134,
      },
      short_description: [
        "<ul>\r\n<li>شاشة LED</li>\r\n<li>قفل للاطفال</li>\r\n<li>تأجيل بدا الغسيل</li>\r\n</ul>",
      ],
      image: ["/n/e/new_project_40_1.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1499.025001,
        price: 1499.025001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=SOUK8H4]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="SOUK8H4"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>\r\n<p style="text-align: right;">خاصية نصف الحمولة&nbsp;</p>\r\n<p style="text-align: right;">&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>&nbsp;الفتح التلقائي للباب بعد نهاية البرنامج</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الغسيل القوي للصحون&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>قفل للأطفال&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تسخين المياه حتي 70 درجة&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تأخير بدء الغسيل&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر مساعد الشطف&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر إضافة الملح&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>فلتر سهل التنظيف&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الرف العلوي مرن قابل للتعديل&nbsp; &nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>إشعار انتهاء البرنامج&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li>\r\n<p style="text-align: right;">السطح الداخلي استانلس استيل&nbsp;</p>\r\n</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10109",
      eligible_for_tamara: [true],
      url_key: [
        "haam-dishwasher-12-places-7-program-white-hmdw1207w23-p-1608122012",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/n/e/new_project_40_1.webp",
            width: 1200,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 12 مكان 7 برامج أبيض HMDW1207W23"],
      back_orders: 0,
      sku: "1608122012",
      stock: {
        is_in_stock: true,
        qty: 170,
      },
      rewrite_url:
        "haam-dishwasher-12-places-7-program-white-hmdw1207w23-p-1608122012",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>12</strong> <strong>مكان</strong> <strong>7</strong> <strong>برامج</strong> <strong>أبيض</strong> <strong>HMDW1207</strong><strong>W</strong><strong>23</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9273",
    _score: null,
    _source: {
      1101: {
        value: 55,
      },
      image: ["/0/1/01df2f38-1c34-4d30-81e6-b7562ea44909_1.jpg"],
      option_text_brand: ["فريجيدير"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 2100.015001,
        price: 2100.015001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9273",
      eligible_for_tamara: [true],
      url_key: [
        "frigidaire-dishwasher-12-places-6-program-white-fdfe12ffgcwd-p-1614300010",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/0/1/01df2f38-1c34-4d30-81e6-b7562ea44909_1.webp",
            width: 400,
            position: "2",
            url: null,
            height: 300,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون فريجدير 12 مكان 6 برامج ابيض FDFE12FFGCWD"],
      back_orders: 0,
      sku: "1614300010",
      stock: {
        is_in_stock: true,
        qty: 67,
      },
      rewrite_url:
        "frigidaire-dishwasher-12-places-6-program-white-fdfe12ffgcwd-p-1614300010",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>فريجدير</strong> <strong>12</strong> <strong>مكان</strong> <strong>6</strong> <strong>برامج</strong> <strong>ابيض</strong> <strong>FDFE12</strong><strong>FFGCWD</strong>",
      ],
    },
    sort: [-2147483648],
  },
];

export const Washer4 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "8540",
    _score: null,
    _source: {
      1101: {
        value: 74,
      },
      short_description: [
        "<ul>\r\n<li>رباعية الغسل</li>\r\n<li>الرف الذكي</li>\r\n<li>NFC </li>\r\n<li>التحكم الأمامي</li>\r\n</ul>",
      ],
      image: ["/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4398.980001,
        price: 4398.980001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "8540",
      eligible_for_tamara: [true],
      url_key: [
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.webp",
            width: 800,
            position: "8",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/9/e/9e18de0b-b76d-49c1-b489-e3687eea35b4_1.webp",
            width: 800,
            position: "9",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/6/b/6be42b81-d317-4515-8948-9dd6b9012c92_1.webp",
            width: 800,
            position: "10",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/0/7/07ffd50c-efa2-42aa-9804-bacc04fbe59e_1.webp",
            width: 800,
            position: "11",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/7/871410e2-c4c1-4302-b4f8-8bb58fe6c302_1.webp",
            width: 800,
            position: "12",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/d/3/d3cb6bbe-1920-4102-898b-f24de06efbc6_1.webp",
            width: 800,
            position: "13",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/2/22093100-4497-4c90-bf75-0597126e3aa4_1.webp",
            width: 800,
            position: "14",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/d/ed3815d3-5e05-44ca-8235-22fb0b4bffcd_1.webp",
            width: 800,
            position: "15",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/4/e/4ee2da32-dbaf-4bf7-8e43-c611b237b4b7.webp",
            width: 800,
            position: "16",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/4/e4e67cec-de03-436c-9433-d1ca86617b68_1.webp",
            width: 800,
            position: "17",
            url: null,
            height: 531,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون LG سعة 14 قطعة ابيض 9 برامج DFB512FW"],
      back_orders: 0,
      sku: "1602223055",
      stock: {
        is_in_stock: true,
        qty: 121,
      },
      rewrite_url:
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>LG</strong> <strong>سعة</strong> <strong>14</strong> <strong>قطعة</strong> <strong>ابيض</strong> <strong>9</strong> <strong>برامج</strong> <strong>DFB512</strong><strong>FW</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "8337",
    _score: null,
    _source: {
      1101: {
        value: 16949,
      },
      short_description: [
        "<ul>\r\n<li>ضوضاء أقل </li>\r\n<li>غسل ثنائي المناطق </li>\r\n<li>إدارة مباشرة بالعاكس </li>\r\n<li>تتسم بالهدوء والكفاءة والموثوقية</li>\r\n<li> دورة التربو</li>\r\n</ul>",
      ],
      image: ["/8/b/8b9231e8-d417-4a8b-8043-7dbd444c2c23.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 5199.035001,
        price: 5199.035001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "8337",
      eligible_for_tamara: [true],
      url_key: [
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-silver-dfb415fp-p-1602220066",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/b/8b9231e8-d417-4a8b-8043-7dbd444c2c23.webp",
            width: 400,
            position: "10",
            url: null,
            height: 300,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون LG فضي 14 مكان 9 برنامج DFB415FP"],
      back_orders: 0,
      sku: "1602220066",
      stock: {
        is_in_stock: true,
        qty: 36000,
      },
      rewrite_url:
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-silver-dfb415fp-p-1602220066",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>LG</strong> <strong>فضي</strong> <strong>14</strong> <strong>مكان</strong> <strong>9</strong> <strong>برنامج</strong> <strong>DFB415</strong><strong>FP</strong>",
      ],
    },
    sort: [-2147483648],
  },
  // this is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "8540",
    _score: null,
    _source: {
      1101: {
        value: 74,
      },
      short_description: [
        "<ul>\r\n<li>رباعية الغسل</li>\r\n<li>الرف الذكي</li>\r\n<li>NFC </li>\r\n<li>التحكم الأمامي</li>\r\n</ul>",
      ],
      image: ["/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4398.980001,
        price: 4398.980001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "8540",
      eligible_for_tamara: [true],
      url_key: [
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.webp",
            width: 800,
            position: "8",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/9/e/9e18de0b-b76d-49c1-b489-e3687eea35b4_1.webp",
            width: 800,
            position: "9",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/6/b/6be42b81-d317-4515-8948-9dd6b9012c92_1.webp",
            width: 800,
            position: "10",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/0/7/07ffd50c-efa2-42aa-9804-bacc04fbe59e_1.webp",
            width: 800,
            position: "11",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/7/871410e2-c4c1-4302-b4f8-8bb58fe6c302_1.webp",
            width: 800,
            position: "12",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/d/3/d3cb6bbe-1920-4102-898b-f24de06efbc6_1.webp",
            width: 800,
            position: "13",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/2/22093100-4497-4c90-bf75-0597126e3aa4_1.webp",
            width: 800,
            position: "14",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/d/ed3815d3-5e05-44ca-8235-22fb0b4bffcd_1.webp",
            width: 800,
            position: "15",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/4/e/4ee2da32-dbaf-4bf7-8e43-c611b237b4b7.webp",
            width: 800,
            position: "16",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/4/e4e67cec-de03-436c-9433-d1ca86617b68_1.webp",
            width: 800,
            position: "17",
            url: null,
            height: 531,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون LG سعة 14 قطعة ابيض 9 برامج DFB512FW"],
      back_orders: 0,
      sku: "1602223055",
      stock: {
        is_in_stock: true,
        qty: 121,
      },
      rewrite_url:
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>LG</strong> <strong>سعة</strong> <strong>14</strong> <strong>قطعة</strong> <strong>ابيض</strong> <strong>9</strong> <strong>برامج</strong> <strong>DFB512</strong><strong>FW</strong>",
      ],
    },
    sort: [-2147483648],
  },
  // this is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "8540",
    _score: null,
    _source: {
      1101: {
        value: 74,
      },
      short_description: [
        "<ul>\r\n<li>رباعية الغسل</li>\r\n<li>الرف الذكي</li>\r\n<li>NFC </li>\r\n<li>التحكم الأمامي</li>\r\n</ul>",
      ],
      image: ["/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4398.980001,
        price: 4398.980001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "8540",
      eligible_for_tamara: [true],
      url_key: [
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.webp",
            width: 800,
            position: "8",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/9/e/9e18de0b-b76d-49c1-b489-e3687eea35b4_1.webp",
            width: 800,
            position: "9",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/6/b/6be42b81-d317-4515-8948-9dd6b9012c92_1.webp",
            width: 800,
            position: "10",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/0/7/07ffd50c-efa2-42aa-9804-bacc04fbe59e_1.webp",
            width: 800,
            position: "11",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/7/871410e2-c4c1-4302-b4f8-8bb58fe6c302_1.webp",
            width: 800,
            position: "12",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/d/3/d3cb6bbe-1920-4102-898b-f24de06efbc6_1.webp",
            width: 800,
            position: "13",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/2/22093100-4497-4c90-bf75-0597126e3aa4_1.webp",
            width: 800,
            position: "14",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/d/ed3815d3-5e05-44ca-8235-22fb0b4bffcd_1.webp",
            width: 800,
            position: "15",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/4/e/4ee2da32-dbaf-4bf7-8e43-c611b237b4b7.webp",
            width: 800,
            position: "16",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/4/e4e67cec-de03-436c-9433-d1ca86617b68_1.webp",
            width: 800,
            position: "17",
            url: null,
            height: 531,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون LG سعة 14 قطعة ابيض 9 برامج DFB512FW"],
      back_orders: 0,
      sku: "1602223055",
      stock: {
        is_in_stock: true,
        qty: 121,
      },
      rewrite_url:
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>LG</strong> <strong>سعة</strong> <strong>14</strong> <strong>قطعة</strong> <strong>ابيض</strong> <strong>9</strong> <strong>برامج</strong> <strong>DFB512</strong><strong>FW</strong>",
      ],
    },
    sort: [-2147483648],
  },
  // this is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "8540",
    _score: null,
    _source: {
      1101: {
        value: 74,
      },
      short_description: [
        "<ul>\r\n<li>رباعية الغسل</li>\r\n<li>الرف الذكي</li>\r\n<li>NFC </li>\r\n<li>التحكم الأمامي</li>\r\n</ul>",
      ],
      image: ["/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4398.980001,
        price: 4398.980001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "8540",
      eligible_for_tamara: [true],
      url_key: [
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac5fce74-61cc-4c23-95ce-dd6809217b53_1.webp",
            width: 800,
            position: "8",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/9/e/9e18de0b-b76d-49c1-b489-e3687eea35b4_1.webp",
            width: 800,
            position: "9",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/6/b/6be42b81-d317-4515-8948-9dd6b9012c92_1.webp",
            width: 800,
            position: "10",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/0/7/07ffd50c-efa2-42aa-9804-bacc04fbe59e_1.webp",
            width: 800,
            position: "11",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/7/871410e2-c4c1-4302-b4f8-8bb58fe6c302_1.webp",
            width: 800,
            position: "12",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/d/3/d3cb6bbe-1920-4102-898b-f24de06efbc6_1.webp",
            width: 800,
            position: "13",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/2/22093100-4497-4c90-bf75-0597126e3aa4_1.webp",
            width: 800,
            position: "14",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/d/ed3815d3-5e05-44ca-8235-22fb0b4bffcd_1.webp",
            width: 800,
            position: "15",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/4/e/4ee2da32-dbaf-4bf7-8e43-c611b237b4b7.webp",
            width: 800,
            position: "16",
            url: null,
            height: 531,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/4/e4e67cec-de03-436c-9433-d1ca86617b68_1.webp",
            width: 800,
            position: "17",
            url: null,
            height: 531,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون LG سعة 14 قطعة ابيض 9 برامج DFB512FW"],
      back_orders: 0,
      sku: "1602223055",
      stock: {
        is_in_stock: true,
        qty: 121,
      },
      rewrite_url:
        "lg-quadwashtm-dishwasher-14-place-setting-easyracktm-plus-dual-zone-wash-thinq-white-dfb512fw-p-1602223055",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>LG</strong> <strong>سعة</strong> <strong>14</strong> <strong>قطعة</strong> <strong>ابيض</strong> <strong>9</strong> <strong>برامج</strong> <strong>DFB512</strong><strong>FW</strong>",
      ],
    },
    sort: [-2147483648],
  },
];

export const Washer5 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7674",
    _score: null,
    _source: {
      1101: {
        value: 1430,
      },
      short_description: [
        '<ul>\r\n<li><span style="color: #000000;">قفل للاطفال</span></li>\r\n<li><span style="color: #000000;">شاشة LED </span></li>\r\n<li><span style="color: #000000;">تأجيل بدا الغسيل </span></li>\r\n</ul>',
      ],
      image: ["/4/2/422a9887-bc32-4ea7-b65a-d23a22355fa2_1.png"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1798.945001,
        price: 1798.945001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=V6ASG8Y]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="V6ASG8Y"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li style="text-align: right;"><span style="color: #000000;">فلتر سهل التنظيف</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر إضافة الملح&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">اشعار انتهاء الغسيل </span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">يرامج متعددة للغسيل</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر مساعد الشطف&nbsp; </span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">خاصية نصف الحمولة&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">ارفف مرنة قابلة للتعديل&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">درجة حرارة المياة تصل إلى 70 درجة&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">السطح الداخلي استانلس استيل مقاوم للصدأ&nbsp;&nbsp;</span></li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "7674",
      eligible_for_tamara: [true],
      url_key: ["haam-dishwasher-14-unit-silver-hm14psdw18-p-1608121021"],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/4/2/422a9887-bc32-4ea7-b65a-d23a22355fa2_1.webp",
            width: 800,
            position: "22",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/0/b/0b897d84-d9d5-4b21-9308-8ef78bae7ce1_1.webp",
            width: 557,
            position: "23",
            url: null,
            height: 800,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 3 ارفف فضي 14 مكان 8 برامج HM14PSDW18"],
      back_orders: 0,
      sku: "1608121021",
      stock: {
        is_in_stock: true,
        qty: 1706,
      },
      rewrite_url: "haam-dishwasher-14-unit-silver-hm14psdw18-p-1608121021",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>3</strong> <strong>ارفف</strong> <strong>فضي</strong> <strong>14</strong> <strong>مكان</strong> <strong>8</strong> <strong>برامج</strong> <strong>HM14</strong><strong>PSDW</strong><strong>18</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7675",
    _score: null,
    _source: {
      1101: {
        value: 781,
      },
      short_description: [
        '<ul>\r\n<li><span style="color: #000000;">شاشة LED </span></li>\r\n<li><span style="color: #000000;">قفل للاطفال </span></li>\r\n<li><span style="color: #000000;">تأجيل بدا الغسيل</span></li>\r\n</ul>',
      ],
      image: ["/5/b/5b8866af-e7d8-4409-86fa-2d43c0a700ea_1.png"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1749.035001,
        price: 1749.035001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=FMLE28L]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="FMLE28L"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر إضافة الملح&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">فلتر سهل التنظيف </span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">اشعار انتهاء الغسيل</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">يرامج متعددة للغسيل</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">خاصية نصف الحمولة&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">مؤشر مساعد الشطف&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">ارفف مرنة قابلة للتعديل&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">درجة حرارة المياة تصل إلى 70 درجة&nbsp;&nbsp;</span></li>\r\n<li style="text-align: right;"><span style="color: #000000;">السطح الداخلي استانلس استيل مقاوم للصدأ&nbsp;&nbsp;</span></li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "7675",
      eligible_for_tamara: [true],
      url_key: ["haam-dishwasher-14-unit-white-hm14pwdw18-p-1608121020"],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/5/b/5b8866af-e7d8-4409-86fa-2d43c0a700ea_1.webp",
            width: 800,
            position: "23",
            url: null,
            height: 600,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 3 ارفف أبيض 14 مكان 8 برامج HM14PWDW18"],
      back_orders: 0,
      sku: "1608121020",
      stock: {
        is_in_stock: true,
        qty: 920,
      },
      rewrite_url: "haam-dishwasher-14-unit-white-hm14pwdw18-p-1608121020",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>3</strong> <strong>ارفف</strong> <strong>أبيض</strong> <strong>14</strong> <strong>مكان</strong> <strong>8</strong> <strong>برامج</strong> <strong>HM14</strong><strong>PWDW</strong><strong>18</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10110",
    _score: null,
    _source: {
      1101: {
        value: 416,
      },
      short_description: [
        "<ul>\r\n<li>شاشة LED</li>\r\n<li>قفل للاطفال</li>\r\n<li>تأجيل بدا الغسيل</li>\r\n</ul>",
      ],
      image: ["/n/e/new_project_1__17_1.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1598.960001,
        price: 1598.960001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=VJDC8DT]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="VJDC8DT"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>\r\n<p style="text-align: right;">خاصية نصف الحمولة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الفتح التلقائي للباب بعد نهاية البرنامج</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الغسيل القوي للصحون </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>قفل للأطفال </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تسخين المياه حتي 70 درجة </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تأخير بدء الغسيل </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر مساعد الشطف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر إضافة الملح </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>فلتر سهل التنظيف </p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الرف العلوي مرن قابل للتعديل </p>\r\n</li>\r\n<li style="text-align: right;">إشعار انتهاء البرنامج </li>\r\n<li style="text-align: right;">السطح الداخلي استانلس استيل</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10110",
      eligible_for_tamara: [true],
      url_key: [
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/n/e/new_project_1__17_1.webp",
            width: 1200,
            position: "3",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23"],
      back_orders: 0,
      sku: "1608122013",
      stock: {
        is_in_stock: true,
        qty: 501,
      },
      rewrite_url:
        "haam-dishwasher-12-places-7-program-steel-hmdw1207s23-p-1608122013",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>12</strong> <strong>مكان</strong> <strong>7</strong> <strong>برامج</strong> <strong>استيل</strong> <strong>HMDW1207</strong><strong>S</strong><strong>23</strong>",
      ],
    },
    sort: [5],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10109",
    _score: null,
    _source: {
      1101: {
        value: 134,
      },
      short_description: [
        "<ul>\r\n<li>شاشة LED</li>\r\n<li>قفل للاطفال</li>\r\n<li>تأجيل بدا الغسيل</li>\r\n</ul>",
      ],
      image: ["/n/e/new_project_40_1.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 1499.025001,
        price: 1499.025001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=SOUK8H4]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="SOUK8H4"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>\r\n<p style="text-align: right;">خاصية نصف الحمولة&nbsp;</p>\r\n<p style="text-align: right;">&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>&nbsp;الفتح التلقائي للباب بعد نهاية البرنامج</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الغسيل القوي للصحون&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>قفل للأطفال&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تسخين المياه حتي 70 درجة&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>تأخير بدء الغسيل&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر مساعد الشطف&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>مؤشر إضافة الملح&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>فلتر سهل التنظيف&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>الرف العلوي مرن قابل للتعديل&nbsp; &nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li style="text-align: right;">\r\n<p>إشعار انتهاء البرنامج&nbsp;</p>\r\n<p>&nbsp;</p>\r\n</li>\r\n<li>\r\n<p style="text-align: right;">السطح الداخلي استانلس استيل&nbsp;</p>\r\n</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10109",
      eligible_for_tamara: [true],
      url_key: [
        "haam-dishwasher-12-places-7-program-white-hmdw1207w23-p-1608122012",
      ],
      product_fees: [],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/n/e/new_project_40_1.webp",
            width: 1200,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7336,
            level: 3,
            name: "غسالات الملابس",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7338,
            level: 4,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7378,
            level: 5,
            name: "غسالات الصحون",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7470,
            level: 4,
            name: "الأجهزة المنزلية",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7473,
            level: 3,
            name: "Recommended 4",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7486,
            level: 4,
            name: "Home Appliances",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7526,
            level: 3,
            name: "جلايات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 7364,
          level: 2,
          name: "الأجهزة المنزلية",
          is_parent: true,
        },
      },
      name: ["غسالة صحون هام 12 مكان 7 برامج أبيض HMDW1207W23"],
      back_orders: 0,
      sku: "1608122012",
      stock: {
        is_in_stock: true,
        qty: 170,
      },
      rewrite_url:
        "haam-dishwasher-12-places-7-program-white-hmdw1207w23-p-1608122012",
    },
    highlight: {
      "name.standard": [
        "<strong>غسالة</strong> <strong>صحون</strong> <strong>هام</strong> <strong>12</strong> <strong>مكان</strong> <strong>7</strong> <strong>برامج</strong> <strong>أبيض</strong> <strong>HMDW1207</strong><strong>W</strong><strong>23</strong>",
      ],
    },
    sort: [-2147483648],
  },
];

//! air=conditions data
export const Air1 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9992",
    _score: null,
    _ignored: ["suggest"],
    _source: {
      1101: {
        value: 872,
      },
      short_description: [
        "<ul>\r\n<li>ريش ذهبية للوحدة الداخلية</li>\r\n<li>مؤقت تشغيل وإيقاف المكيف</li>\r\n<li>حفظ وإستعادة الإعدادات</li>\r\n<li>خاصية التبريد السريع (تيربو)</li>\r\n<li>تشخيص ذاتي للأعطال</li>\r\n</ul>",
      ],
      image: ["/_/1/_12_18_24_1_1.png"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 2540.005001,
        price: 2540.005001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9992",
      eligible_for_tamara: [true],
      url_key: ["haam-split-ac-18300-btu-cold-hm18csm23go-p-2608192020"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2608171030,2601124011,2601124041,2601125040,2602250031,2602250011,2602250010,2602250050,2602250051,2602250041,2602250040,2602260051,2602260050,2602260041,2602260040,2602260030,2602260011,2608165020,2608165010,2608164051,2608164050,2608164041,2608164040,2608164031,2608164030,2608164011,2608164010,2608180041,2608180050,2608180040,2608180031,2608180021,2608180011,2608180030,2608180010,2608190050,2608190041,2608190040,2608190031,2608190030,2608190021,2608190011,2608663050,2608673050,2608673040,2608673031,2608673030,2608673021,2608673011,2608683050,2608683040,2608683030,2608683021,2608683020,2608683010,2644620041,2644620031,2644620021,2644620011,2615180030,2615180031,2608165011,2608180020,2602260031,2608190010,2608190020,2608190051,2615181015,2615181016,2615181020,2615181021,2608164020,2608164021,2602260010,2608191010,2608191011,2608191020,2608191021,2608191030,2608191031,2609120020,2609120030,2609120040,2603223220,2603223221,2603223231,2603223230,2608693010,2608693020,2608693021,2608180110,2608180111,2608180120,2608180121,2608180130,2608180131,2608180140,2608180141,2608180150,2608192010,2608192011,2608192020,2608192021,2608192031,2608192030,2608192040,2608192041,2608192050,2608192051,2602270010,2602270011,2602270020,2602270021,2602270030,2602270031,2602270040,2602270041,2602270050,2602270051,2608693110,2608693111,2608693120,2608693121,2608693130,2608693131,2608693140,2608192033","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "AC Installation Split 115 SAR",
          required: "0",
          payment_methods: null,
          options: {
            8: {
              is_free_for_some_cities: "0",
              field_label: "Installation Service-SAR 0.00",
              fee_option_id: "8",
              is_default: "0",
              title: "Installation Service",
              title_ar: "خدمة تركيب",
              price: "115.0000",
              fee_id: "4",
              price_type: "fixed",
              default_title: "Installation Service",
              field_label_ar: "خدمة تركيب-SAR 0.00",
              position: "2",
              store_default_title: "Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "23",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "2875.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "4",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/_/1/_12_18_24_1_1.webp",
            width: 1919,
            position: "1",
            url: null,
            height: 707,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/_/2/_2023_1_1.webp",
            width: 900,
            position: "2",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/h/m/hm18csm23go.webp",
            width: 706,
            position: "5",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف هام جداري الذهبي  18300 بارد ريش ذهبية  HM18CSM23GO"],
      back_orders: 0,
      sku: "2608192020",
      stock: {
        is_in_stock: true,
        qty: 1082,
      },
      rewrite_url: "haam-split-ac-18300-btu-cold-hm18csm23go-p-2608192020",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>هام</strong> <strong>جداري</strong> <strong>الذهبي</strong>  <strong>18300</strong> <strong>بارد</strong> <strong>ريش</strong> <strong>ذهبية</strong>  <strong>HM18</strong><strong>CSM</strong><strong>23</strong><strong>GO</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7842",
    _score: null,
    _source: {
      1101: {
        value: 16949,
      },
      image: ["/6/1/61ca76c9-8c7b-4cc9-9d6e-25d98f7b3abb_1_1_1_1.jpg"],
      option_text_brand: ["إم تي سي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 2685.020001,
        price: 2685.020001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=N6Q27JM]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="N6Q27JM"><div data-content-type="text" data-appearance="default" data-element="main"><p style="text-align: right;">توزيع رباعي الإتجاهات - وضع النوم - وظيفة I Feel : تعتمد هذه الوظيفة على قياس درجة الحرارة للهواء المحيط بوحدة التحكم بدلاً من الوحدة الداخلية لضبط أكثر دقة وراحة - تنبيه بتنظيف الفلتر - ذاكرة لحفظ وضعية موزع الهواء الأفقي - وظيفة TURBO - زر التشغيل اليدوي - مؤقت 24 ساعة - مانع للجليد - إعادة التشغيل التلقائي - فلتر عالي الكثافة - شاشة LED - خرطوم تصريف الماء علي الجانبين - تشخيص ذاتي للأعطال</p></div></div></div>',
      ],
      label: [],
      entity_id: "7842",
      eligible_for_tamara: [true],
      url_key: ["mtc-split-ac-18000-btu-cold-mtc18ct22n-p-2608683020"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2608171030,2601124011,2601124041,2601125040,2602250031,2602250011,2602250010,2602250050,2602250051,2602250041,2602250040,2602260051,2602260050,2602260041,2602260040,2602260030,2602260011,2608165020,2608165010,2608164051,2608164050,2608164041,2608164040,2608164031,2608164030,2608164011,2608164010,2608180041,2608180050,2608180040,2608180031,2608180021,2608180011,2608180030,2608180010,2608190050,2608190041,2608190040,2608190031,2608190030,2608190021,2608190011,2608663050,2608673050,2608673040,2608673031,2608673030,2608673021,2608673011,2608683050,2608683040,2608683030,2608683021,2608683020,2608683010,2644620041,2644620031,2644620021,2644620011,2615180030,2615180031,2608165011,2608180020,2602260031,2608190010,2608190020,2608190051,2615181015,2615181016,2615181020,2615181021,2608164020,2608164021,2602260010,2608191010,2608191011,2608191020,2608191021,2608191030,2608191031,2609120020,2609120030,2609120040,2603223220,2603223221,2603223231,2603223230,2608693010,2608693020,2608693021,2608180110,2608180111,2608180120,2608180121,2608180130,2608180131,2608180140,2608180141,2608180150,2608192010,2608192011,2608192020,2608192021,2608192031,2608192030,2608192040,2608192041,2608192050,2608192051,2602270010,2602270011,2602270020,2602270021,2602270030,2602270031,2602270040,2602270041,2602270050,2602270051,2608693110,2608693111,2608693120,2608693121,2608693130,2608693131,2608693140,2608192033","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "AC Installation Split 115 SAR",
          required: "0",
          payment_methods: null,
          options: {
            8: {
              is_free_for_some_cities: "0",
              field_label: "Installation Service-SAR 0.00",
              fee_option_id: "8",
              is_default: "0",
              title: "Installation Service",
              title_ar: "خدمة تركيب",
              price: "115.0000",
              fee_id: "4",
              price_type: "fixed",
              default_title: "Installation Service",
              field_label_ar: "خدمة تركيب-SAR 0.00",
              position: "2",
              store_default_title: "Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "23",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "2875.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "4",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/6/1/61ca76c9-8c7b-4cc9-9d6e-25d98f7b3abb_1_1_1_1.webp",
            width: 800,
            position: "0",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/3/83b5cbe7-3efa-4a18-a41e-a594a15ced29_1_1_1_1.webp",
            width: 800,
            position: "1",
            url: null,
            height: 395,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/4/24922de4-3bbe-4f2b-9620-7d7046e4c91d_1_1_1_1.webp",
            width: 800,
            position: "2",
            url: null,
            height: 533,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/0/c/0c75f6fc-c771-491b-bc80-509c52e94adc_1_1_1_1.webp",
            width: 600,
            position: "3",
            url: null,
            height: 800,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/7/c/7c2b37b0-df59-4169-9930-cd7333664a7f.webp",
            width: 471,
            position: "4",
            url: null,
            height: 800,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف MTC جداري 18000 بارد توزيع رباعي MTC18CT22N"],
      back_orders: 0,
      sku: "2608683020",
      stock: {
        is_in_stock: true,
        qty: 36000,
      },
      rewrite_url: "mtc-split-ac-18000-btu-cold-mtc18ct22n-p-2608683020",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>MTC</strong> <strong>جداري</strong> <strong>18000</strong> <strong>بارد</strong> <strong>توزيع</strong> <strong>رباعي</strong> <strong>MTC</strong><strong>18</strong><strong>CT</strong><strong>22</strong>N",
      ],
    },
    sort: [-2147483648],
  },
  // this data is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7814",
    _score: null,
    _source: {
      1101: {
        value: 16949,
      },
      image: ["/e/a/eac71473-7b3e-4c57-a251-0f6254ad508b_1_1_1_1.jpg"],
      option_text_brand: ["إم تي سي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 2885.005001,
        price: 2885.005001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=EMEJ7G7]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="EMEJ7G7"><div data-content-type="text" data-appearance="default" data-element="main"><p style="text-align: right;">وضع النوم - وظيفة I Feel : تعتمد هذه الوظيفة على قياس درجة الحرارة للهواء المحيط بوحدة التحكم بدلاً من الوحدة الداخلية لضبط أكثر دقة وراحة - تنبيه بتنظيف الفلتر - ذاكرة لحفظ وضعية موزع الهواء الأفقي - وظيفة TURBO - زر التشغيل اليدوي - مؤقت 24 ساعة - مانع للجليد - إعادة التشغيل التلقائي - فلتر عالي الكثافة - شاشة LED - خرطوم تصريف الماء علي الجانبين - تشخيص ذاتي للأعطال</p></div></div></div>',
      ],
      label: [],
      entity_id: "7814",
      eligible_for_tamara: [true],
      url_key: ["mtc-split-ac-18000-btu-hot-cold-mtc18ht21n-p-2608673021"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2608171030,2601124011,2601124041,2601125040,2602250031,2602250011,2602250010,2602250050,2602250051,2602250041,2602250040,2602260051,2602260050,2602260041,2602260040,2602260030,2602260011,2608165020,2608165010,2608164051,2608164050,2608164041,2608164040,2608164031,2608164030,2608164011,2608164010,2608180041,2608180050,2608180040,2608180031,2608180021,2608180011,2608180030,2608180010,2608190050,2608190041,2608190040,2608190031,2608190030,2608190021,2608190011,2608663050,2608673050,2608673040,2608673031,2608673030,2608673021,2608673011,2608683050,2608683040,2608683030,2608683021,2608683020,2608683010,2644620041,2644620031,2644620021,2644620011,2615180030,2615180031,2608165011,2608180020,2602260031,2608190010,2608190020,2608190051,2615181015,2615181016,2615181020,2615181021,2608164020,2608164021,2602260010,2608191010,2608191011,2608191020,2608191021,2608191030,2608191031,2609120020,2609120030,2609120040,2603223220,2603223221,2603223231,2603223230,2608693010,2608693020,2608693021,2608180110,2608180111,2608180120,2608180121,2608180130,2608180131,2608180140,2608180141,2608180150,2608192010,2608192011,2608192020,2608192021,2608192031,2608192030,2608192040,2608192041,2608192050,2608192051,2602270010,2602270011,2602270020,2602270021,2602270030,2602270031,2602270040,2602270041,2602270050,2602270051,2608693110,2608693111,2608693120,2608693121,2608693130,2608693131,2608693140,2608192033","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "AC Installation Split 115 SAR",
          required: "0",
          payment_methods: null,
          options: {
            8: {
              is_free_for_some_cities: "0",
              field_label: "Installation Service-SAR 0.00",
              fee_option_id: "8",
              is_default: "0",
              title: "Installation Service",
              title_ar: "خدمة تركيب",
              price: "115.0000",
              fee_id: "4",
              price_type: "fixed",
              default_title: "Installation Service",
              field_label_ar: "خدمة تركيب-SAR 0.00",
              position: "2",
              store_default_title: "Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "23",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "2875.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "4",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/a/eac71473-7b3e-4c57-a251-0f6254ad508b_1_1_1_1.webp",
            width: 800,
            position: "1",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/b/8bffea28-a032-4a25-89e2-e499d038fcd9.webp",
            width: 705,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف MTC جداري 18000 حار بارد توزيع رباعي MTC18HT21N"],
      back_orders: 0,
      sku: "2608673021",
      stock: {
        is_in_stock: true,
        qty: 36000,
      },
      rewrite_url: "mtc-split-ac-18000-btu-hot-cold-mtc18ht21n-p-2608673021",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>MTC</strong> <strong>جداري</strong> <strong>18000</strong> حار <strong>بارد</strong> <strong>توزيع</strong> <strong>رباعي</strong> <strong>MTC</strong><strong>18</strong><strong>HT</strong><strong>21</strong>N",
      ],
    },
    sort: [-2147483648],
  },
  // this data is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7814",
    _score: null,
    _source: {
      1101: {
        value: 16949,
      },
      image: ["/e/a/eac71473-7b3e-4c57-a251-0f6254ad508b_1_1_1_1.jpg"],
      option_text_brand: ["إم تي سي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 2885.005001,
        price: 2885.005001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=EMEJ7G7]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="EMEJ7G7"><div data-content-type="text" data-appearance="default" data-element="main"><p style="text-align: right;">وضع النوم - وظيفة I Feel : تعتمد هذه الوظيفة على قياس درجة الحرارة للهواء المحيط بوحدة التحكم بدلاً من الوحدة الداخلية لضبط أكثر دقة وراحة - تنبيه بتنظيف الفلتر - ذاكرة لحفظ وضعية موزع الهواء الأفقي - وظيفة TURBO - زر التشغيل اليدوي - مؤقت 24 ساعة - مانع للجليد - إعادة التشغيل التلقائي - فلتر عالي الكثافة - شاشة LED - خرطوم تصريف الماء علي الجانبين - تشخيص ذاتي للأعطال</p></div></div></div>',
      ],
      label: [],
      entity_id: "7814",
      eligible_for_tamara: [true],
      url_key: ["mtc-split-ac-18000-btu-hot-cold-mtc18ht21n-p-2608673021"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2608171030,2601124011,2601124041,2601125040,2602250031,2602250011,2602250010,2602250050,2602250051,2602250041,2602250040,2602260051,2602260050,2602260041,2602260040,2602260030,2602260011,2608165020,2608165010,2608164051,2608164050,2608164041,2608164040,2608164031,2608164030,2608164011,2608164010,2608180041,2608180050,2608180040,2608180031,2608180021,2608180011,2608180030,2608180010,2608190050,2608190041,2608190040,2608190031,2608190030,2608190021,2608190011,2608663050,2608673050,2608673040,2608673031,2608673030,2608673021,2608673011,2608683050,2608683040,2608683030,2608683021,2608683020,2608683010,2644620041,2644620031,2644620021,2644620011,2615180030,2615180031,2608165011,2608180020,2602260031,2608190010,2608190020,2608190051,2615181015,2615181016,2615181020,2615181021,2608164020,2608164021,2602260010,2608191010,2608191011,2608191020,2608191021,2608191030,2608191031,2609120020,2609120030,2609120040,2603223220,2603223221,2603223231,2603223230,2608693010,2608693020,2608693021,2608180110,2608180111,2608180120,2608180121,2608180130,2608180131,2608180140,2608180141,2608180150,2608192010,2608192011,2608192020,2608192021,2608192031,2608192030,2608192040,2608192041,2608192050,2608192051,2602270010,2602270011,2602270020,2602270021,2602270030,2602270031,2602270040,2602270041,2602270050,2602270051,2608693110,2608693111,2608693120,2608693121,2608693130,2608693131,2608693140,2608192033","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "AC Installation Split 115 SAR",
          required: "0",
          payment_methods: null,
          options: {
            8: {
              is_free_for_some_cities: "0",
              field_label: "Installation Service-SAR 0.00",
              fee_option_id: "8",
              is_default: "0",
              title: "Installation Service",
              title_ar: "خدمة تركيب",
              price: "115.0000",
              fee_id: "4",
              price_type: "fixed",
              default_title: "Installation Service",
              field_label_ar: "خدمة تركيب-SAR 0.00",
              position: "2",
              store_default_title: "Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "23",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "2875.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "4",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/e/a/eac71473-7b3e-4c57-a251-0f6254ad508b_1_1_1_1.webp",
            width: 800,
            position: "1",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/8/b/8bffea28-a032-4a25-89e2-e499d038fcd9.webp",
            width: 705,
            position: "2",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف MTC جداري 18000 حار بارد توزيع رباعي MTC18HT21N"],
      back_orders: 0,
      sku: "2608673021",
      stock: {
        is_in_stock: true,
        qty: 36000,
      },
      rewrite_url: "mtc-split-ac-18000-btu-hot-cold-mtc18ht21n-p-2608673021",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>MTC</strong> <strong>جداري</strong> <strong>18000</strong> حار <strong>بارد</strong> <strong>توزيع</strong> <strong>رباعي</strong> <strong>MTC</strong><strong>18</strong><strong>HT</strong><strong>21</strong>N",
      ],
    },
    sort: [-2147483648],
  },
];

export const Air2 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7852",
    _score: null,
    _source: {
      1101: {
        value: 16949,
      },
      image: ["/3/4/3472b2ee-0db5-4254-90bb-7930927d9cac_1_1.jpg"],
      option_text_brand: ["تيرم"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4069.965001,
        price: 4069.965001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=KTLKSP2]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="KTLKSP2"><div data-content-type="text" data-appearance="default" data-element="main"><p style="text-align: right;">توزيع رباعي الإتجاهات - ريش ذهبية للوحدة الداخلية - تقنية الواي فاي - فلتر ثلاثي صحي - مؤقت تشغيل وإيقاف المكيف - (I FEEL ) قياس درجة الحرارة المحيطة بوحدة التحكم بدلا من الوحدة الداخلية - تشخيص ذاتي للأعطال - (TURBO) التبريد أو التدفئة السريعة - إعادة التشغيل التلقائي - شاشة LED - وضع النوم - هدوء تام - كاشف تسريب الفريون - مانع للجليد - ذاكرة لحفظ وضعية موزع الهواء - خرطوم تصريف علي الجانبين - زر التشغيل اليدوي</p></div></div></div>',
      ],
      label: [],
      entity_id: "7852",
      eligible_for_tamara: [true],
      url_key: ["terim-split-ac-22000-btu-cold-wifi-trg24cs21wf-p-2608815030"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2605426690,2605427310,2604730021,2605426689,2608181030,2608181050,2608815011,2608815040,2608815030,2608815020,2608815010,2644128021,2644128020,2644128011,2644128016,2644128015,2644128010,2619920105,2619920106,2619922008,2619922007,2619922002,2619922001,2622532024,2622531030,2622531020,2622531041,2622540005,2622560021,2608815021,2608815031,2608815050,2622531021,2644128025,2608814030,2608816010,2608816020,2608816021,2608816030,2608816031,2608816040,2608816050,2605427420,2605427430,2605427440,2605427450,2605427460,2608817020,2608817030,2608198021,2608198031,2608198041,2608816011,2619920211,2619920220,2619920221,2619920230,2619920231,2619920250,2619920260,2619920261,2622532121,2622532130,2622532140,2622532141,2622532150,2622532151,2622532120,2622531010,2622531011,2622532033,2608197041,2622532131,2644211010,2644211020,2644211030,2644211040","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "4 M. Extension and Installation Service 230 SAR",
          required: "0",
          payment_methods: null,
          options: {
            10: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "10",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "230.0000",
              fee_id: "5",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000003",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "24",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "5750.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "5",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/3/4/3472b2ee-0db5-4254-90bb-7930927d9cac_1_1.webp",
            width: 800,
            position: "1",
            url: null,
            height: 600,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/b/b/bbb39e21-832a-46db-b5a6-160c05a1cca0.webp",
            width: 471,
            position: "2",
            url: null,
            height: 800,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف تيرم جداري 22000 وحدة بارد (واي فاي) TRG24CS21WF"],
      back_orders: 0,
      sku: "2608815030",
      stock: {
        is_in_stock: true,
        qty: 36000,
      },
      rewrite_url:
        "terim-split-ac-22000-btu-cold-wifi-trg24cs21wf-p-2608815030",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>تيرم</strong> <strong>جداري</strong> <strong>22000</strong> <strong>وحدة</strong> <strong>بارد</strong> (<strong>واي</strong> <strong>فاي</strong>) <strong>TRG</strong><strong>24</strong><strong>CS</strong><strong>21</strong><strong>WF</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9996",
    _score: null,
    _ignored: ["suggest"],
    _source: {
      1101: {
        value: 1184,
      },
      short_description: [
        "<ul>\r\n<li>ريش ذهبية للوحدة الداخلية</li>\r\n<li>مؤقت تشغيل وإيقاف المكيف</li>\r\n<li>حفظ وإستعادة الإعدادات</li>\r\n<li>خاصية التبريد السريع (تيربو)</li>\r\n<li>تشخيص ذاتي للأعطال</li>\r\n</ul>",
      ],
      image: ["/_/1/_12_18_24_1_1_1_2_1.png"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 3240.010001,
        price: 3240.010001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9996",
      eligible_for_tamara: [true],
      url_key: ["haam-split-ac-22000-btu-cold-hm24csm23go-p-2608192030"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2608171030,2601124011,2601124041,2601125040,2602250031,2602250011,2602250010,2602250050,2602250051,2602250041,2602250040,2602260051,2602260050,2602260041,2602260040,2602260030,2602260011,2608165020,2608165010,2608164051,2608164050,2608164041,2608164040,2608164031,2608164030,2608164011,2608164010,2608180041,2608180050,2608180040,2608180031,2608180021,2608180011,2608180030,2608180010,2608190050,2608190041,2608190040,2608190031,2608190030,2608190021,2608190011,2608663050,2608673050,2608673040,2608673031,2608673030,2608673021,2608673011,2608683050,2608683040,2608683030,2608683021,2608683020,2608683010,2644620041,2644620031,2644620021,2644620011,2615180030,2615180031,2608165011,2608180020,2602260031,2608190010,2608190020,2608190051,2615181015,2615181016,2615181020,2615181021,2608164020,2608164021,2602260010,2608191010,2608191011,2608191020,2608191021,2608191030,2608191031,2609120020,2609120030,2609120040,2603223220,2603223221,2603223231,2603223230,2608693010,2608693020,2608693021,2608180110,2608180111,2608180120,2608180121,2608180130,2608180131,2608180140,2608180141,2608180150,2608192010,2608192011,2608192020,2608192021,2608192031,2608192030,2608192040,2608192041,2608192050,2608192051,2602270010,2602270011,2602270020,2602270021,2602270030,2602270031,2602270040,2602270041,2602270050,2602270051,2608693110,2608693111,2608693120,2608693121,2608693130,2608693131,2608693140,2608192033","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "AC Installation Split 115 SAR",
          required: "0",
          payment_methods: null,
          options: {
            8: {
              is_free_for_some_cities: "0",
              field_label: "Installation Service-SAR 0.00",
              fee_option_id: "8",
              is_default: "0",
              title: "Installation Service",
              title_ar: "خدمة تركيب",
              price: "115.0000",
              fee_id: "4",
              price_type: "fixed",
              default_title: "Installation Service",
              field_label_ar: "خدمة تركيب-SAR 0.00",
              position: "2",
              store_default_title: "Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "23",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "2875.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "4",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/png/media/catalog/product/_/1/_12_18_24_1_1_1_2_1.webp",
            width: 1919,
            position: "1",
            url: null,
            height: 707,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/_/2/_2023_1_1_1_2_1.webp",
            width: 900,
            position: "2",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/h/m/hm24csm23go_mtc-151847.webp",
            width: 706,
            position: "11",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: [" مكيف هام جداري الذهبي  22000 بارد ريش ذهبية HM24CSM23GO"],
      back_orders: 0,
      sku: "2608192030",
      stock: {
        is_in_stock: true,
        qty: 1324,
      },
      rewrite_url: "haam-split-ac-22000-btu-cold-hm24csm23go-p-2608192030",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>هام</strong> <strong>جداري</strong> <strong>الذهبي</strong>  <strong>22000</strong> <strong>بارد</strong> <strong>ريش</strong> <strong>ذهبية</strong> <strong>HM24</strong><strong>CSM</strong><strong>23</strong><strong>GO</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10457",
    _score: null,
    _source: {
      1101: {
        value: 132,
      },
      short_description: [
        "<ul>\r\n<li> فلتر عالي الكثافة</li>\r\n<li>إعادة التشغيل التلقائي </li>\r\n<li>شاشة LED</li>\r\n</ul>",
      ],
      image: ["/_/1/_12-24_mtc-166370.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 3439.995001,
        price: 3439.995001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=RU2K2J5]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="RU2K2J5"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>Four-way distribution</li>\r\n<li>Cold models only. Golden blades for the indoor unit only</li>\r\n<li>Hot models cool golden blades in the indoor and outdoor unit</li>\r\n<li>FOLLOW ME</li>\r\n<li>Self-cleaning</li>\r\n<li>sleep mode</li>\r\n<li>Air conditioner on and off timer</li>\r\n<li>Save and restore settings</li>\r\n<li>Rapid cooling feature (turbo)</li>\r\n<li>Self-diagnosis of faults</li>\r\n<li>Turns the indoor unit display on or off</li>\r\n<li>Child lock on the remote control</li>\r\n<li>Freon leak detector</li>\r\n<li>anti-icing</li>\r\n<li>Memory to save the position of the air distributor</li>\r\n<li>Drainage hose on both sides</li>\r\n<li>Manual operation button</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10457",
      eligible_for_tamara: [true],
      url_key: ["haam-split-ac-22000-btu-cold-hot-hm24hsm23go-p-2608192033"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2608171030,2601124011,2601124041,2601125040,2602250031,2602250011,2602250010,2602250050,2602250051,2602250041,2602250040,2602260051,2602260050,2602260041,2602260040,2602260030,2602260011,2608165020,2608165010,2608164051,2608164050,2608164041,2608164040,2608164031,2608164030,2608164011,2608164010,2608180041,2608180050,2608180040,2608180031,2608180021,2608180011,2608180030,2608180010,2608190050,2608190041,2608190040,2608190031,2608190030,2608190021,2608190011,2608663050,2608673050,2608673040,2608673031,2608673030,2608673021,2608673011,2608683050,2608683040,2608683030,2608683021,2608683020,2608683010,2644620041,2644620031,2644620021,2644620011,2615180030,2615180031,2608165011,2608180020,2602260031,2608190010,2608190020,2608190051,2615181015,2615181016,2615181020,2615181021,2608164020,2608164021,2602260010,2608191010,2608191011,2608191020,2608191021,2608191030,2608191031,2609120020,2609120030,2609120040,2603223220,2603223221,2603223231,2603223230,2608693010,2608693020,2608693021,2608180110,2608180111,2608180120,2608180121,2608180130,2608180131,2608180140,2608180141,2608180150,2608192010,2608192011,2608192020,2608192021,2608192031,2608192030,2608192040,2608192041,2608192050,2608192051,2602270010,2602270011,2602270020,2602270021,2602270030,2602270031,2602270040,2602270041,2602270050,2602270051,2608693110,2608693111,2608693120,2608693121,2608693130,2608693131,2608693140,2608192033","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "AC Installation Split 115 SAR",
          required: "0",
          payment_methods: null,
          options: {
            8: {
              is_free_for_some_cities: "0",
              field_label: "Installation Service-SAR 0.00",
              fee_option_id: "8",
              is_default: "0",
              title: "Installation Service",
              title_ar: "خدمة تركيب",
              price: "115.0000",
              fee_id: "4",
              price_type: "fixed",
              default_title: "Installation Service",
              field_label_ar: "خدمة تركيب-SAR 0.00",
              position: "2",
              store_default_title: "Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "23",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "2875.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "4",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/_/1/_12-24_mtc-166370.webp",
            width: 1919,
            position: "1",
            url: null,
            height: 707,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/_/2/_2023_mtc-166371.webp",
            width: 900,
            position: "2",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2608192033.webp",
            width: 706,
            position: "3",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف هام جداري الذهبي22000 حار بارد ريش ذهبية HM24HSM23GO-NU"],
      back_orders: 0,
      sku: "2608192033",
      stock: {
        is_in_stock: true,
        qty: 154,
      },
      rewrite_url: "haam-split-ac-22000-btu-cold-hot-hm24hsm23go-p-2608192033",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>هام</strong> <strong>جداري</strong> <strong>الذهبي22000</strong> <strong>حار</strong> <strong>بارد</strong> <strong>ريش</strong> <strong>ذهبية</strong> <strong>HM24</strong><strong>HSM</strong><strong>23</strong><strong>GO</strong>-<strong>NU</strong>",
      ],
    },
    sort: [12],
  },
  // this data is not the real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "10457",
    _score: null,
    _source: {
      1101: {
        value: 132,
      },
      short_description: [
        "<ul>\r\n<li> فلتر عالي الكثافة</li>\r\n<li>إعادة التشغيل التلقائي </li>\r\n<li>شاشة LED</li>\r\n</ul>",
      ],
      image: ["/_/1/_12-24_mtc-166370.jpg"],
      option_text_brand: ["هام"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 3439.995001,
        price: 3439.995001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      description: [
        '<style>#html-body [data-pb-style=RU2K2J5]{justify-content:flex-start;display:flex;flex-direction:column;background-position:left top;background-size:cover;background-repeat:no-repeat;background-attachment:scroll}</style><div data-content-type="row" data-appearance="contained" data-element="main"><div data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}" data-background-type="image" data-video-loop="true" data-video-play-only-visible="true" data-video-lazy-load="true" data-video-fallback-src="" data-element="inner" data-pb-style="RU2K2J5"><div data-content-type="text" data-appearance="default" data-element="main"><ul>\r\n<li>Four-way distribution</li>\r\n<li>Cold models only. Golden blades for the indoor unit only</li>\r\n<li>Hot models cool golden blades in the indoor and outdoor unit</li>\r\n<li>FOLLOW ME</li>\r\n<li>Self-cleaning</li>\r\n<li>sleep mode</li>\r\n<li>Air conditioner on and off timer</li>\r\n<li>Save and restore settings</li>\r\n<li>Rapid cooling feature (turbo)</li>\r\n<li>Self-diagnosis of faults</li>\r\n<li>Turns the indoor unit display on or off</li>\r\n<li>Child lock on the remote control</li>\r\n<li>Freon leak detector</li>\r\n<li>anti-icing</li>\r\n<li>Memory to save the position of the air distributor</li>\r\n<li>Drainage hose on both sides</li>\r\n<li>Manual operation button</li>\r\n</ul></div></div></div>',
      ],
      label: [],
      entity_id: "10457",
      eligible_for_tamara: [true],
      url_key: ["haam-split-ac-22000-btu-cold-hot-hm24hsm23go-p-2608192033"],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2608171030,2601124011,2601124041,2601125040,2602250031,2602250011,2602250010,2602250050,2602250051,2602250041,2602250040,2602260051,2602260050,2602260041,2602260040,2602260030,2602260011,2608165020,2608165010,2608164051,2608164050,2608164041,2608164040,2608164031,2608164030,2608164011,2608164010,2608180041,2608180050,2608180040,2608180031,2608180021,2608180011,2608180030,2608180010,2608190050,2608190041,2608190040,2608190031,2608190030,2608190021,2608190011,2608663050,2608673050,2608673040,2608673031,2608673030,2608673021,2608673011,2608683050,2608683040,2608683030,2608683021,2608683020,2608683010,2644620041,2644620031,2644620021,2644620011,2615180030,2615180031,2608165011,2608180020,2602260031,2608190010,2608190020,2608190051,2615181015,2615181016,2615181020,2615181021,2608164020,2608164021,2602260010,2608191010,2608191011,2608191020,2608191021,2608191030,2608191031,2609120020,2609120030,2609120040,2603223220,2603223221,2603223231,2603223230,2608693010,2608693020,2608693021,2608180110,2608180111,2608180120,2608180121,2608180130,2608180131,2608180140,2608180141,2608180150,2608192010,2608192011,2608192020,2608192021,2608192031,2608192030,2608192040,2608192041,2608192050,2608192051,2602270010,2602270011,2602270020,2602270021,2602270030,2602270031,2602270040,2602270041,2602270050,2602270051,2608693110,2608693111,2608693120,2608693121,2608693130,2608693131,2608693140,2608192033","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "0",
          title: "AC Installation Split 115 SAR",
          required: "0",
          payment_methods: null,
          options: {
            8: {
              is_free_for_some_cities: "0",
              field_label: "Installation Service-SAR 0.00",
              fee_option_id: "8",
              is_default: "0",
              title: "Installation Service",
              title_ar: "خدمة تركيب",
              price: "115.0000",
              fee_id: "4",
              price_type: "fixed",
              default_title: "Installation Service",
              field_label_ar: "خدمة تركيب-SAR 0.00",
              position: "2",
              store_default_title: "Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "23",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "2875.00",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "4",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/_/1/_12-24_mtc-166370.webp",
            width: 1919,
            position: "1",
            url: null,
            height: 707,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/_/2/_2023_mtc-166371.webp",
            width: 900,
            position: "2",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2608192033.webp",
            width: 706,
            position: "3",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7556,
            level: 2,
            name: "GTIN Products",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7561,
            level: 2,
            name: "Weekend Offers",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف هام جداري الذهبي22000 حار بارد ريش ذهبية HM24HSM23GO-NU"],
      back_orders: 0,
      sku: "2608192033",
      stock: {
        is_in_stock: true,
        qty: 154,
      },
      rewrite_url: "haam-split-ac-22000-btu-cold-hot-hm24hsm23go-p-2608192033",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>هام</strong> <strong>جداري</strong> <strong>الذهبي22000</strong> <strong>حار</strong> <strong>بارد</strong> <strong>ريش</strong> <strong>ذهبية</strong> <strong>HM24</strong><strong>HSM</strong><strong>23</strong><strong>GO</strong>-<strong>NU</strong>",
      ],
    },
    sort: [12],
  },
];

export const Air3 = [
  
]

export const Air4 = [
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9202",
    _score: null,
    _source: {
      1101: {
        value: 64,
      },
      short_description: [
        "<ul>\r\n<li>ال جي مكيف سبليت 18400 وحدة بارد فقط</li>\r\n<li>جيت كول وفلتر غبار مضاد للبكتيريا</li>\r\n<li>توزيع الهواء 4 اتجاهات</li>\r\n<li>تنظيف ذاتي</li>\r\n<li>مؤقت 24 ساعة</li>\r\n<li>ريش ذهبية.</li>\r\n</ul>",
      ],
      image: ["/2/6/2605426962-1_3.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4098.485001,
        price: 4098.485001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9202",
      eligible_for_tamara: [true],
      url_key: [
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-1_3.webp",
            width: 1100,
            position: "1",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-2_3.webp",
            width: 1100,
            position: "2",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-3_3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-4_3.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-5_3.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-6_3.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-8_3.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-9_3.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-10_3.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-11_3.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-12_3.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-13_3.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-15_3.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-16_3.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac062240268_18k_co__mtc-122243.webp",
            width: 706,
            position: "15",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG جيت كول 18400 وحدة بارد LO182C0 NK0 LO182C0 UK0"],
      back_orders: 0,
      sku: "2605426962",
      stock: {
        is_in_stock: true,
        qty: 232,
      },
      rewrite_url:
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>جيت</strong> <strong>كول</strong> <strong>18400</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>NK0</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>UK0</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9204",
    _score: null,
    _source: {
      1101: {
        value: 104,
      },
      short_description: [
        "<ul>\r\n<li>ال جي مكيف سبليت 22800 وحدة بارد فقط</li>\r\n<li>جيت كول وفلتر غبار مضاد للبكتيريا</li>\r\n<li>توزيع الهواء 4 اتجاهات</li>\r\n<li>تنظيف ذاتي</li>\r\n<li>مؤقت 24 ساعة</li>\r\n<li>ريش ذهبية</li>\r\n</ul>",
      ],
      image: ["/c/l/close_front_mtc-122247_1_1.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4798.490001,
        price: 4798.490001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9204",
      eligible_for_tamara: [true],
      url_key: [
        "lg-jet-cool-split-ac-22800-btu-cool-only-lo242c0-nk0-lo242c0-uk0-p-2605426970",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/c/l/close_front_mtc-122247_1_1.webp",
            width: 1200,
            position: "0",
            url: null,
            height: 1200,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-1.webp",
            width: 1100,
            position: "1",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-5.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-6.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-7.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-8.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-9.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-10.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-11.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-12.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-13.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-14.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426970-15.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac062240273_24k_co__mtc-122245.webp",
            width: 706,
            position: "15",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG جيت كول 22800 وحدة بارد LO242C0 NK0 LO242C0 UK0"],
      back_orders: 0,
      sku: "2605426970",
      stock: {
        is_in_stock: true,
        qty: 163,
      },
      rewrite_url:
        "lg-jet-cool-split-ac-22800-btu-cool-only-lo242c0-nk0-lo242c0-uk0-p-2605426970",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>جيت</strong> <strong>كول</strong> <strong>22800</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>LO242</strong><strong>C</strong><strong>0</strong> <strong>NK0</strong> <strong>LO242</strong><strong>C</strong><strong>0</strong> <strong>UK0</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7255",
    _score: null,
    _source: {
      1101: {
        value: 120,
      },
      image: ["/2/6/2605426951-1.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 5169.480001,
        price: 5169.480001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "7255",
      eligible_for_tamara: [true],
      url_key: [
        "lg-ac-split-fresh-inverter-18000-btu-heat-cool-nf182h2-nk1-nf182h2-uk1-p-2605426951",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-1.webp",
            width: 1100,
            position: "2",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-4.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-5.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-6.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-7.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-8.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-9.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-10.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-11.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-12.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-13.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-14.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-15.webp",
            width: 1100,
            position: "15",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426951-2.webp",
            width: 1100,
            position: "16",
            url: null,
            height: 730,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG فريش انفرتر 18000 حار بارد NF182H2 NK1 - NF182H2 UK1"],
      back_orders: 0,
      sku: "2605426951",
      stock: {
        is_in_stock: true,
        qty: 138,
      },
      rewrite_url:
        "lg-ac-split-fresh-inverter-18000-btu-heat-cool-nf182h2-nk1-nf182h2-uk1-p-2605426951",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>فريش</strong> <strong>انفرتر</strong> <strong>18000</strong> <strong>حار</strong> <strong>بارد</strong> <strong>NF182</strong><strong>H</strong><strong>2</strong> <strong>NK1</strong> - <strong>NF182</strong><strong>H</strong><strong>2</strong> <strong>UK1</strong>",
      ],
    },
    sort: [-2147483648],
  },
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "7256",
    _score: null,
    _source: {
      1101: {
        value: 354,
      },
      image: ["/2/6/2605426960-1.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 5619.475001,
        price: 5619.475001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "7256",
      eligible_for_tamara: [true],
      url_key: [
        "lg-ac-split-fresh-inverter-21500-btu-cool-only-nf242c3-nk1-nf242c3-uk1-p-2605426960",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-1.webp",
            width: 1100,
            position: "2",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-4.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-5.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-6.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-7.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-8.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-9.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-10.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-11.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-12.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-13.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-14.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-15.webp",
            width: 1100,
            position: "15",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426960-2.webp",
            width: 1100,
            position: "16",
            url: null,
            height: 730,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7415,
            level: 2,
            name: "العروض",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG فريش انفرتر 21500 بارد NF242C3 NK1 - NF242C3 UK1"],
      back_orders: 0,
      sku: "2605426960",
      stock: {
        is_in_stock: true,
        qty: 391,
      },
      rewrite_url:
        "lg-ac-split-fresh-inverter-21500-btu-cool-only-nf242c3-nk1-nf242c3-uk1-p-2605426960",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>فريش</strong> <strong>انفرتر</strong> <strong>21500</strong> <strong>بارد</strong> <strong>NF242</strong><strong>C</strong><strong>3</strong> <strong>NK1</strong> - <strong>NF242</strong><strong>C</strong><strong>3</strong> <strong>UK1</strong>",
      ],
    },
    sort: [-2147483648],
  },
];

export const Air5 = [
  // this data is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9202",
    _score: null,
    _source: {
      1101: {
        value: 64,
      },
      short_description: [
        "<ul>\r\n<li>ال جي مكيف سبليت 18400 وحدة بارد فقط</li>\r\n<li>جيت كول وفلتر غبار مضاد للبكتيريا</li>\r\n<li>توزيع الهواء 4 اتجاهات</li>\r\n<li>تنظيف ذاتي</li>\r\n<li>مؤقت 24 ساعة</li>\r\n<li>ريش ذهبية.</li>\r\n</ul>",
      ],
      image: ["/2/6/2605426962-1_3.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4098.485001,
        price: 4098.485001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9202",
      eligible_for_tamara: [true],
      url_key: [
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-1_3.webp",
            width: 1100,
            position: "1",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-2_3.webp",
            width: 1100,
            position: "2",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-3_3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-4_3.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-5_3.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-6_3.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-8_3.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-9_3.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-10_3.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-11_3.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-12_3.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-13_3.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-15_3.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-16_3.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac062240268_18k_co__mtc-122243.webp",
            width: 706,
            position: "15",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG جيت كول 18400 وحدة بارد LO182C0 NK0 LO182C0 UK0"],
      back_orders: 0,
      sku: "2605426962",
      stock: {
        is_in_stock: true,
        qty: 232,
      },
      rewrite_url:
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>جيت</strong> <strong>كول</strong> <strong>18400</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>NK0</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>UK0</strong>",
      ],
    },
    sort: [-2147483648],
  },
  // this data is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9202",
    _score: null,
    _source: {
      1101: {
        value: 64,
      },
      short_description: [
        "<ul>\r\n<li>ال جي مكيف سبليت 18400 وحدة بارد فقط</li>\r\n<li>جيت كول وفلتر غبار مضاد للبكتيريا</li>\r\n<li>توزيع الهواء 4 اتجاهات</li>\r\n<li>تنظيف ذاتي</li>\r\n<li>مؤقت 24 ساعة</li>\r\n<li>ريش ذهبية.</li>\r\n</ul>",
      ],
      image: ["/2/6/2605426962-1_3.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4098.485001,
        price: 4098.485001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9202",
      eligible_for_tamara: [true],
      url_key: [
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-1_3.webp",
            width: 1100,
            position: "1",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-2_3.webp",
            width: 1100,
            position: "2",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-3_3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-4_3.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-5_3.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-6_3.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-8_3.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-9_3.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-10_3.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-11_3.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-12_3.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-13_3.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-15_3.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-16_3.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac062240268_18k_co__mtc-122243.webp",
            width: 706,
            position: "15",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG جيت كول 18400 وحدة بارد LO182C0 NK0 LO182C0 UK0"],
      back_orders: 0,
      sku: "2605426962",
      stock: {
        is_in_stock: true,
        qty: 232,
      },
      rewrite_url:
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>جيت</strong> <strong>كول</strong> <strong>18400</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>NK0</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>UK0</strong>",
      ],
    },
    sort: [-2147483648],
  },
  // this data is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9202",
    _score: null,
    _source: {
      1101: {
        value: 64,
      },
      short_description: [
        "<ul>\r\n<li>ال جي مكيف سبليت 18400 وحدة بارد فقط</li>\r\n<li>جيت كول وفلتر غبار مضاد للبكتيريا</li>\r\n<li>توزيع الهواء 4 اتجاهات</li>\r\n<li>تنظيف ذاتي</li>\r\n<li>مؤقت 24 ساعة</li>\r\n<li>ريش ذهبية.</li>\r\n</ul>",
      ],
      image: ["/2/6/2605426962-1_3.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4098.485001,
        price: 4098.485001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9202",
      eligible_for_tamara: [true],
      url_key: [
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-1_3.webp",
            width: 1100,
            position: "1",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-2_3.webp",
            width: 1100,
            position: "2",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-3_3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-4_3.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-5_3.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-6_3.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-8_3.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-9_3.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-10_3.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-11_3.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-12_3.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-13_3.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-15_3.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-16_3.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac062240268_18k_co__mtc-122243.webp",
            width: 706,
            position: "15",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG جيت كول 18400 وحدة بارد LO182C0 NK0 LO182C0 UK0"],
      back_orders: 0,
      sku: "2605426962",
      stock: {
        is_in_stock: true,
        qty: 232,
      },
      rewrite_url:
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>جيت</strong> <strong>كول</strong> <strong>18400</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>NK0</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>UK0</strong>",
      ],
    },
    sort: [-2147483648],
  },
];

export const Air6 = [
  // this data is not real data
  {
    _index: "almanea_ar_catalog_product_20240521_105952",
    _id: "9202",
    _score: null,
    _source: {
      1101: {
        value: 64,
      },
      short_description: [
        "<ul>\r\n<li>ال جي مكيف سبليت 18400 وحدة بارد فقط</li>\r\n<li>جيت كول وفلتر غبار مضاد للبكتيريا</li>\r\n<li>توزيع الهواء 4 اتجاهات</li>\r\n<li>تنظيف ذاتي</li>\r\n<li>مؤقت 24 ساعة</li>\r\n<li>ريش ذهبية.</li>\r\n</ul>",
      ],
      image: ["/2/6/2605426962-1_3.jpg"],
      option_text_brand: ["إل جي"],
      prices_with_tax: {
        discounted_price_to: "2024-04-10 11:30:07",
        original_price: 4098.485001,
        price: 4098.485001,
        is_count_down: false,
        discounted_price_from: "2024-04-08 11:30:07",
      },
      type_id: "simple",
      label: [],
      entity_id: "9202",
      eligible_for_tamara: [true],
      url_key: [
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
      ],
      product_fees: [
        {
          apply_per: "per_item",
          description: "",
          actions_serialized:
            '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
          type: "4",
          enable_customer_message: "1",
          title: "4 M. Extension and Installation Service 172 SAR",
          required: "0",
          payment_methods: null,
          options: {
            12: {
              is_free_for_some_cities: "0",
              field_label: "4 M. Extension and Installation Service-SAR 0.00",
              fee_option_id: "12",
              is_default: "0",
              title: "4 M. Extension and Installation Service",
              title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
              price: "172.5000",
              fee_id: "6",
              price_type: "fixed",
              default_title: "4 M. Extension and Installation Service",
              field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
              position: "2",
              store_default_title: "4 M. Extension and Installation Service",
              city_list: null,
            },
          },
          date_field_title: "",
          sku: "2689000001",
          sort_order: "0",
          store_code: "en",
          store_id: ["0"],
          _first_store_id: "2",
          is_onetime: "0",
          total_ordered: "9",
          min_amount: "",
          input_type: "radio",
          applied_totals: "subtotal",
          tax_class_id: "0",
          conditions_serialized:
            '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
          customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
          labels: {
            2: {
              description: "",
              date_field_title: "",
              title: "Added Services",
              customer_message_title: "",
            },
            14: {
              description: "",
              date_field_title: "",
              title: "خدمات اضافيه",
              customer_message_title: "",
            },
          },
          total_base_amount: "1552.50",
          shipping_methods: null,
          count_percent_from: "product",
          fee_id: "6",
          use_bundle_qty: "1",
          enable_date_field: "0",
          unit_count: "1.0000",
          status: "1",
        },
      ],
      custom_related_products: [],
      _media_: {
        image: [
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-1_3.webp",
            width: 1100,
            position: "1",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-2_3.webp",
            width: 1100,
            position: "2",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-3_3.webp",
            width: 1100,
            position: "3",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-4_3.webp",
            width: 1100,
            position: "4",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-5_3.webp",
            width: 1100,
            position: "5",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-6_3.webp",
            width: 1100,
            position: "6",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-8_3.webp",
            width: 1100,
            position: "7",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-9_3.webp",
            width: 1100,
            position: "8",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-10_3.webp",
            width: 1100,
            position: "9",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-11_3.webp",
            width: 1100,
            position: "10",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-12_3.webp",
            width: 1100,
            position: "11",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-13_3.webp",
            width: 1100,
            position: "12",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-15_3.webp",
            width: 1100,
            position: "13",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-16_3.webp",
            width: 1100,
            position: "14",
            url: null,
            height: 730,
          },
          {
            image:
              "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac062240268_18k_co__mtc-122243.webp",
            width: 706,
            position: "15",
            url: null,
            height: 1200,
          },
        ],
      },
      eligible_for_tabby: [true],
      fast_delivery: [true],
      _category_: {
        sub_categories: [
          {
            is_virtual: false,
            code: "category",
            category_id: 539,
            level: 3,
            name: "اسبليت",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7421,
            level: 2,
            name: "عروض العودة للمدارس",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7450,
            level: 2,
            name: "Almanea App",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7451,
            level: 3,
            name: "app slider",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7456,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7457,
            level: 3,
            name: "Recommended 3",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7460,
            level: 3,
            name: "Products Tab",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7461,
            level: 3,
            name: "Bannercenter2",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7462,
            level: 3,
            name: "Bannercenter1",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7468,
            level: 3,
            name: "categories home app",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7469,
            level: 4,
            name: "أجهزة التكييف",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7476,
            level: 3,
            name: "Categories Tabs",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7477,
            level: 3,
            name: "Top Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7478,
            level: 3,
            name: "Top Categories Helpsi deals",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7479,
            level: 3,
            name: "Featured Categories new",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7480,
            level: 3,
            name: "Featured Categories hot",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7481,
            level: 3,
            name: "Featured Categories specal offer",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7483,
            level: 3,
            name: "Home Story",
            is_parent: false,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7484,
            level: 4,
            name: "Air Conditioners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7490,
            level: 3,
            name: "Top Categories Banners",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7491,
            level: 4,
            name: "عروض رمضان",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7501,
            level: 4,
            name: "عروض العيد",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7510,
            level: 3,
            name: "المكيفات",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7529,
            level: 2,
            name: "Brands",
            is_parent: true,
          },
          {
            is_virtual: false,
            code: "category",
            category_id: 7531,
            level: 2,
            name: "Test 10",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7532,
            level: 3,
            name: "Test 11",
            is_parent: true,
          },
          {
            is_virtual: true,
            code: "category",
            category_id: 7534,
            level: 3,
            name: "LG",
            is_parent: true,
          },
        ],
        catalog: [],
        main_category: {
          is_virtual: false,
          code: "category",
          category_id: 535,
          level: 2,
          name: "أجهزة التكييف",
          is_parent: true,
        },
      },
      name: ["مكيف LG جيت كول 18400 وحدة بارد LO182C0 NK0 LO182C0 UK0"],
      back_orders: 0,
      sku: "2605426962",
      stock: {
        is_in_stock: true,
        qty: 232,
      },
      rewrite_url:
        "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
    },
    highlight: {
      "name.standard": [
        "<strong>مكيف</strong> <strong>LG</strong> <strong>جيت</strong> <strong>كول</strong> <strong>18400</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>NK0</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>UK0</strong>",
      ],
    },
    sort: [-2147483648],
  },
 // this data is not real data
 {
  _index: "almanea_ar_catalog_product_20240521_105952",
  _id: "9202",
  _score: null,
  _source: {
    1101: {
      value: 64,
    },
    short_description: [
      "<ul>\r\n<li>ال جي مكيف سبليت 18400 وحدة بارد فقط</li>\r\n<li>جيت كول وفلتر غبار مضاد للبكتيريا</li>\r\n<li>توزيع الهواء 4 اتجاهات</li>\r\n<li>تنظيف ذاتي</li>\r\n<li>مؤقت 24 ساعة</li>\r\n<li>ريش ذهبية.</li>\r\n</ul>",
    ],
    image: ["/2/6/2605426962-1_3.jpg"],
    option_text_brand: ["إل جي"],
    prices_with_tax: {
      discounted_price_to: "2024-04-10 11:30:07",
      original_price: 4098.485001,
      price: 4098.485001,
      is_count_down: false,
      discounted_price_from: "2024-04-08 11:30:07",
    },
    type_id: "simple",
    label: [],
    entity_id: "9202",
    eligible_for_tamara: [true],
    url_key: [
      "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
    ],
    product_fees: [
      {
        apply_per: "per_item",
        description: "",
        actions_serialized:
          '{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine","attribute":null,"operator":null,"value":"1","is_value_processed":null,"aggregator":"all","conditions":[{"type":"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product","attribute":"sku","operator":"()","value":"2604094020,2604094021,2605426950,2605426951,2605426960,2605426961,2604094011,2605426912,2605426923,2605426922,2605426913,2605426910,2605426921,2605426920,2604002031,2604002021,2604002030,2604002010,2604002041,2604002011,2604002040,2604002020,2605426911,2605426962,2605426963,2605426970,2605426971,2601127010,2601127011,2601127020,2601127021,2601127030,2601127031,2601127040,2601127041,2601127050,2601127051,2605441010,2605441011,2605442020,2605442021,2605442030,2605442031","is_value_processed":false,"attribute_scope":""}]}',
        type: "4",
        enable_customer_message: "1",
        title: "4 M. Extension and Installation Service 172 SAR",
        required: "0",
        payment_methods: null,
        options: {
          12: {
            is_free_for_some_cities: "0",
            field_label: "4 M. Extension and Installation Service-SAR 0.00",
            fee_option_id: "12",
            is_default: "0",
            title: "4 M. Extension and Installation Service",
            title_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
            price: "172.5000",
            fee_id: "6",
            price_type: "fixed",
            default_title: "4 M. Extension and Installation Service",
            field_label_ar: "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
            position: "2",
            store_default_title: "4 M. Extension and Installation Service",
            city_list: null,
          },
        },
        date_field_title: "",
        sku: "2689000001",
        sort_order: "0",
        store_code: "en",
        store_id: ["0"],
        _first_store_id: "2",
        is_onetime: "0",
        total_ordered: "9",
        min_amount: "",
        input_type: "radio",
        applied_totals: "subtotal",
        tax_class_id: "0",
        conditions_serialized:
          '{"type":"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine","attribute":null,"operator":null,"value":true,"is_value_processed":null,"aggregator":"all"}',
        customer_message_title: "هل ترغب فى العبور من غير خدمة التركيب ",
        labels: {
          2: {
            description: "",
            date_field_title: "",
            title: "Added Services",
            customer_message_title: "",
          },
          14: {
            description: "",
            date_field_title: "",
            title: "خدمات اضافيه",
            customer_message_title: "",
          },
        },
        total_base_amount: "1552.50",
        shipping_methods: null,
        count_percent_from: "product",
        fee_id: "6",
        use_bundle_qty: "1",
        enable_date_field: "0",
        unit_count: "1.0000",
        status: "1",
      },
    ],
    custom_related_products: [],
    _media_: {
      image: [
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-1_3.webp",
          width: 1100,
          position: "1",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-2_3.webp",
          width: 1100,
          position: "2",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-3_3.webp",
          width: 1100,
          position: "3",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-4_3.webp",
          width: 1100,
          position: "4",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-5_3.webp",
          width: 1100,
          position: "5",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-6_3.webp",
          width: 1100,
          position: "6",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-8_3.webp",
          width: 1100,
          position: "7",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-9_3.webp",
          width: 1100,
          position: "8",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-10_3.webp",
          width: 1100,
          position: "9",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-11_3.webp",
          width: 1100,
          position: "10",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-12_3.webp",
          width: 1100,
          position: "11",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-13_3.webp",
          width: 1100,
          position: "12",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-15_3.webp",
          width: 1100,
          position: "13",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/2/6/2605426962-16_3.webp",
          width: 1100,
          position: "14",
          url: null,
          height: 730,
        },
        {
          image:
            "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/c/ac062240268_18k_co__mtc-122243.webp",
          width: 706,
          position: "15",
          url: null,
          height: 1200,
        },
      ],
    },
    eligible_for_tabby: [true],
    fast_delivery: [true],
    _category_: {
      sub_categories: [
        {
          is_virtual: false,
          code: "category",
          category_id: 539,
          level: 3,
          name: "اسبليت",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7421,
          level: 2,
          name: "عروض العودة للمدارس",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7450,
          level: 2,
          name: "Almanea App",
          is_parent: false,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7451,
          level: 3,
          name: "app slider",
          is_parent: false,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7456,
          level: 4,
          name: "عروض رمضان",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7457,
          level: 3,
          name: "Recommended 3",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7460,
          level: 3,
          name: "Products Tab",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7461,
          level: 3,
          name: "Bannercenter2",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7462,
          level: 3,
          name: "Bannercenter1",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7468,
          level: 3,
          name: "categories home app",
          is_parent: false,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7469,
          level: 4,
          name: "أجهزة التكييف",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7476,
          level: 3,
          name: "Categories Tabs",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7477,
          level: 3,
          name: "Top Categories hot",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7478,
          level: 3,
          name: "Top Categories Helpsi deals",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7479,
          level: 3,
          name: "Featured Categories new",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7480,
          level: 3,
          name: "Featured Categories hot",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7481,
          level: 3,
          name: "Featured Categories specal offer",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7483,
          level: 3,
          name: "Home Story",
          is_parent: false,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7484,
          level: 4,
          name: "Air Conditioners",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7490,
          level: 3,
          name: "Top Categories Banners",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7491,
          level: 4,
          name: "عروض رمضان",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7501,
          level: 4,
          name: "عروض العيد",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7510,
          level: 3,
          name: "المكيفات",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7529,
          level: 2,
          name: "Brands",
          is_parent: true,
        },
        {
          is_virtual: false,
          code: "category",
          category_id: 7531,
          level: 2,
          name: "Test 10",
          is_parent: true,
        },
        {
          is_virtual: true,
          code: "category",
          category_id: 7532,
          level: 3,
          name: "Test 11",
          is_parent: true,
        },
        {
          is_virtual: true,
          code: "category",
          category_id: 7534,
          level: 3,
          name: "LG",
          is_parent: true,
        },
      ],
      catalog: [],
      main_category: {
        is_virtual: false,
        code: "category",
        category_id: 535,
        level: 2,
        name: "أجهزة التكييف",
        is_parent: true,
      },
    },
    name: ["مكيف LG جيت كول 18400 وحدة بارد LO182C0 NK0 LO182C0 UK0"],
    back_orders: 0,
    sku: "2605426962",
    stock: {
      is_in_stock: true,
      qty: 232,
    },
    rewrite_url:
      "lg-jet-cool-split-ac-18400-btu-cool-only-lo182c0-nk0-lo182c0-uk0-p-2605426962",
  },
  highlight: {
    "name.standard": [
      "<strong>مكيف</strong> <strong>LG</strong> <strong>جيت</strong> <strong>كول</strong> <strong>18400</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>NK0</strong> <strong>LO182</strong><strong>C</strong><strong>0</strong> <strong>UK0</strong>",
    ],
  },
  sort: [-2147483648],
},
];

export const Air7 = [
  {
    "_index": "almanea_ar_catalog_product_20240521_105952",
    "_id": "7864",
    "_score": null,
    "_source": {
        "1101": {
            "value": 26
        },
        "image": [
            "/f/5/f5d5aeb7-1bde-4248-ac5e-9a3952262167_1_1_1_1.jpg"
        ],
        "option_text_brand": [
            "اوجنرال"
        ],
        "prices_with_tax": {
            "discounted_price_to": "2024-04-10 11:30:07",
            "original_price": 6612.960001,
            "price": 6612.960001,
            "is_count_down": false,
            "discounted_price_from": "2024-04-08 11:30:07"
        },
        "type_id": "simple",
        "label": [],
        "entity_id": "7864",
        "eligible_for_tamara": [
            true
        ],
        "url_key": [
            "o-general-split-ac-24000-btu-cold-only-assa24futa-aosa24futah-p-2644128015"
        ],
        "product_fees": [
            {
                "apply_per": "per_item",
                "description": "",
                "actions_serialized": "{\"type\":\"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine\",\"attribute\":null,\"operator\":null,\"value\":\"1\",\"is_value_processed\":null,\"aggregator\":\"all\",\"conditions\":[{\"type\":\"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\",\"attribute\":\"sku\",\"operator\":\"()\",\"value\":\"2605426690,2605427310,2604730021,2605426689,2608181030,2608181050,2608815011,2608815040,2608815030,2608815020,2608815010,2644128021,2644128020,2644128011,2644128016,2644128015,2644128010,2619920105,2619920106,2619922008,2619922007,2619922002,2619922001,2622532024,2622531030,2622531020,2622531041,2622540005,2622560021,2608815021,2608815031,2608815050,2622531021,2644128025,2608814030,2608816010,2608816020,2608816021,2608816030,2608816031,2608816040,2608816050,2605427420,2605427430,2605427440,2605427450,2605427460,2608817020,2608817030,2608198021,2608198031,2608198041,2608816011,2619920211,2619920220,2619920221,2619920230,2619920231,2619920250,2619920260,2619920261,2622532121,2622532130,2622532140,2622532141,2622532150,2622532151,2622532120,2622531010,2622531011,2622532033,2608197041,2622532131,2644211010,2644211020,2644211030,2644211040\",\"is_value_processed\":false,\"attribute_scope\":\"\"}]}",
                "type": "4",
                "enable_customer_message": "0",
                "title": "4 M. Extension and Installation Service 230 SAR",
                "required": "0",
                "payment_methods": null,
                "options": {
                    "10": {
                        "is_free_for_some_cities": "0",
                        "field_label": "4 M. Extension and Installation Service-SAR 0.00",
                        "fee_option_id": "10",
                        "is_default": "0",
                        "title": "4 M. Extension and Installation Service",
                        "title_ar": "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
                        "price": "230.0000",
                        "fee_id": "5",
                        "price_type": "fixed",
                        "default_title": "4 M. Extension and Installation Service",
                        "field_label_ar": "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
                        "position": "2",
                        "store_default_title": "4 M. Extension and Installation Service",
                        "city_list": null
                    }
                },
                "date_field_title": "",
                "sku": "2689000003",
                "sort_order": "0",
                "store_code": "en",
                "store_id": [
                    "0"
                ],
                "_first_store_id": "2",
                "is_onetime": "0",
                "total_ordered": "24",
                "min_amount": "",
                "input_type": "radio",
                "applied_totals": "subtotal",
                "tax_class_id": "0",
                "conditions_serialized": "{\"type\":\"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine\",\"attribute\":null,\"operator\":null,\"value\":true,\"is_value_processed\":null,\"aggregator\":\"all\"}",
                "customer_message_title": "",
                "labels": {
                    "2": {
                        "description": "",
                        "date_field_title": "",
                        "title": "Added Services",
                        "customer_message_title": ""
                    },
                    "14": {
                        "description": "",
                        "date_field_title": "",
                        "title": "خدمات اضافيه",
                        "customer_message_title": ""
                    }
                },
                "total_base_amount": "5750.00",
                "shipping_methods": null,
                "count_percent_from": "product",
                "fee_id": "5",
                "use_bundle_qty": "1",
                "enable_date_field": "0",
                "unit_count": "1.0000",
                "status": "1"
            }
        ],
        "custom_related_products": [],
        "_media_": {
            "image": [
                {
                    "image": "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/f/5/f5d5aeb7-1bde-4248-ac5e-9a3952262167_1_1_1_1.webp",
                    "width": 800,
                    "position": "1",
                    "url": null,
                    "height": 600
                },
                {
                    "image": "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/s/assa24futaz.webp",
                    "width": 740,
                    "position": "2",
                    "url": null,
                    "height": 1200
                }
            ]
        },
        "eligible_for_tabby": [
            true
        ],
        "fast_delivery": [
            true
        ],
        "_category_": {
            "sub_categories": [
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 539,
                    "level": 3,
                    "name": "اسبليت",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7415,
                    "level": 2,
                    "name": "العروض",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7421,
                    "level": 2,
                    "name": "عروض العودة للمدارس",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7450,
                    "level": 2,
                    "name": "Almanea App",
                    "is_parent": false
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7451,
                    "level": 3,
                    "name": "app slider",
                    "is_parent": false
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7456,
                    "level": 4,
                    "name": "عروض رمضان",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7457,
                    "level": 3,
                    "name": "Recommended 3",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7460,
                    "level": 3,
                    "name": "Products Tab",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7461,
                    "level": 3,
                    "name": "Bannercenter2",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7468,
                    "level": 3,
                    "name": "categories home app",
                    "is_parent": false
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7469,
                    "level": 4,
                    "name": "أجهزة التكييف",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7476,
                    "level": 3,
                    "name": "Categories Tabs",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7477,
                    "level": 3,
                    "name": "Top Categories hot",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7478,
                    "level": 3,
                    "name": "Top Categories Helpsi deals",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7479,
                    "level": 3,
                    "name": "Featured Categories new",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7480,
                    "level": 3,
                    "name": "Featured Categories hot",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7481,
                    "level": 3,
                    "name": "Featured Categories specal offer",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7483,
                    "level": 3,
                    "name": "Home Story",
                    "is_parent": false
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7484,
                    "level": 4,
                    "name": "Air Conditioners",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7490,
                    "level": 3,
                    "name": "Top Categories Banners",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7491,
                    "level": 4,
                    "name": "عروض رمضان",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7501,
                    "level": 4,
                    "name": "عروض العيد",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7510,
                    "level": 3,
                    "name": "المكيفات",
                    "is_parent": true
                },
                {
                    "is_virtual": false,
                    "code": "category",
                    "category_id": 7531,
                    "level": 2,
                    "name": "Test 10",
                    "is_parent": true
                },
                {
                    "is_virtual": true,
                    "code": "category",
                    "category_id": 7532,
                    "level": 3,
                    "name": "Test 11",
                    "is_parent": true
                }
            ],
            "catalog": [],
            "main_category": {
                "is_virtual": false,
                "code": "category",
                "category_id": 535,
                "level": 2,
                "name": "أجهزة التكييف",
                "is_parent": true
            }
        },
        "name": [
            "مكيف اوجنرال جدارى 24000 وحدة بارد ASSA24FUTA AOSA24FUTAH"
        ],
        "back_orders": 0,
        "sku": "2644128015",
        "stock": {
            "is_in_stock": true,
            "qty": 66
        },
        "rewrite_url": "o-general-split-ac-24000-btu-cold-only-assa24futa-aosa24futah-p-2644128015"
    },
    "highlight": {
        "name.standard": [
            "<strong>مكيف</strong> <strong>اوجنرال</strong> <strong>جدارى</strong> <strong>24000</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>ASSA24</strong><strong>FUTA</strong> <strong>AOSA24</strong><strong>FUTAH</strong>"
        ]
    },
    "sort": [
        -2147483648
    ]
},
// this data is not real data 
{
  "_index": "almanea_ar_catalog_product_20240521_105952",
  "_id": "7864",
  "_score": null,
  "_source": {
      "1101": {
          "value": 26
      },
      "image": [
          "/f/5/f5d5aeb7-1bde-4248-ac5e-9a3952262167_1_1_1_1.jpg"
      ],
      "option_text_brand": [
          "اوجنرال"
      ],
      "prices_with_tax": {
          "discounted_price_to": "2024-04-10 11:30:07",
          "original_price": 6612.960001,
          "price": 6612.960001,
          "is_count_down": false,
          "discounted_price_from": "2024-04-08 11:30:07"
      },
      "type_id": "simple",
      "label": [],
      "entity_id": "7864",
      "eligible_for_tamara": [
          true
      ],
      "url_key": [
          "o-general-split-ac-24000-btu-cold-only-assa24futa-aosa24futah-p-2644128015"
      ],
      "product_fees": [
          {
              "apply_per": "per_item",
              "description": "",
              "actions_serialized": "{\"type\":\"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine\",\"attribute\":null,\"operator\":null,\"value\":\"1\",\"is_value_processed\":null,\"aggregator\":\"all\",\"conditions\":[{\"type\":\"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\",\"attribute\":\"sku\",\"operator\":\"()\",\"value\":\"2605426690,2605427310,2604730021,2605426689,2608181030,2608181050,2608815011,2608815040,2608815030,2608815020,2608815010,2644128021,2644128020,2644128011,2644128016,2644128015,2644128010,2619920105,2619920106,2619922008,2619922007,2619922002,2619922001,2622532024,2622531030,2622531020,2622531041,2622540005,2622560021,2608815021,2608815031,2608815050,2622531021,2644128025,2608814030,2608816010,2608816020,2608816021,2608816030,2608816031,2608816040,2608816050,2605427420,2605427430,2605427440,2605427450,2605427460,2608817020,2608817030,2608198021,2608198031,2608198041,2608816011,2619920211,2619920220,2619920221,2619920230,2619920231,2619920250,2619920260,2619920261,2622532121,2622532130,2622532140,2622532141,2622532150,2622532151,2622532120,2622531010,2622531011,2622532033,2608197041,2622532131,2644211010,2644211020,2644211030,2644211040\",\"is_value_processed\":false,\"attribute_scope\":\"\"}]}",
              "type": "4",
              "enable_customer_message": "0",
              "title": "4 M. Extension and Installation Service 230 SAR",
              "required": "0",
              "payment_methods": null,
              "options": {
                  "10": {
                      "is_free_for_some_cities": "0",
                      "field_label": "4 M. Extension and Installation Service-SAR 0.00",
                      "fee_option_id": "10",
                      "is_default": "0",
                      "title": "4 M. Extension and Installation Service",
                      "title_ar": "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
                      "price": "230.0000",
                      "fee_id": "5",
                      "price_type": "fixed",
                      "default_title": "4 M. Extension and Installation Service",
                      "field_label_ar": "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
                      "position": "2",
                      "store_default_title": "4 M. Extension and Installation Service",
                      "city_list": null
                  }
              },
              "date_field_title": "",
              "sku": "2689000003",
              "sort_order": "0",
              "store_code": "en",
              "store_id": [
                  "0"
              ],
              "_first_store_id": "2",
              "is_onetime": "0",
              "total_ordered": "24",
              "min_amount": "",
              "input_type": "radio",
              "applied_totals": "subtotal",
              "tax_class_id": "0",
              "conditions_serialized": "{\"type\":\"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine\",\"attribute\":null,\"operator\":null,\"value\":true,\"is_value_processed\":null,\"aggregator\":\"all\"}",
              "customer_message_title": "",
              "labels": {
                  "2": {
                      "description": "",
                      "date_field_title": "",
                      "title": "Added Services",
                      "customer_message_title": ""
                  },
                  "14": {
                      "description": "",
                      "date_field_title": "",
                      "title": "خدمات اضافيه",
                      "customer_message_title": ""
                  }
              },
              "total_base_amount": "5750.00",
              "shipping_methods": null,
              "count_percent_from": "product",
              "fee_id": "5",
              "use_bundle_qty": "1",
              "enable_date_field": "0",
              "unit_count": "1.0000",
              "status": "1"
          }
      ],
      "custom_related_products": [],
      "_media_": {
          "image": [
              {
                  "image": "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/f/5/f5d5aeb7-1bde-4248-ac5e-9a3952262167_1_1_1_1.webp",
                  "width": 800,
                  "position": "1",
                  "url": null,
                  "height": 600
              },
              {
                  "image": "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/s/assa24futaz.webp",
                  "width": 740,
                  "position": "2",
                  "url": null,
                  "height": 1200
              }
          ]
      },
      "eligible_for_tabby": [
          true
      ],
      "fast_delivery": [
          true
      ],
      "_category_": {
          "sub_categories": [
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 539,
                  "level": 3,
                  "name": "اسبليت",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7415,
                  "level": 2,
                  "name": "العروض",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7421,
                  "level": 2,
                  "name": "عروض العودة للمدارس",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7450,
                  "level": 2,
                  "name": "Almanea App",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7451,
                  "level": 3,
                  "name": "app slider",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7456,
                  "level": 4,
                  "name": "عروض رمضان",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7457,
                  "level": 3,
                  "name": "Recommended 3",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7460,
                  "level": 3,
                  "name": "Products Tab",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7461,
                  "level": 3,
                  "name": "Bannercenter2",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7468,
                  "level": 3,
                  "name": "categories home app",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7469,
                  "level": 4,
                  "name": "أجهزة التكييف",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7476,
                  "level": 3,
                  "name": "Categories Tabs",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7477,
                  "level": 3,
                  "name": "Top Categories hot",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7478,
                  "level": 3,
                  "name": "Top Categories Helpsi deals",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7479,
                  "level": 3,
                  "name": "Featured Categories new",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7480,
                  "level": 3,
                  "name": "Featured Categories hot",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7481,
                  "level": 3,
                  "name": "Featured Categories specal offer",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7483,
                  "level": 3,
                  "name": "Home Story",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7484,
                  "level": 4,
                  "name": "Air Conditioners",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7490,
                  "level": 3,
                  "name": "Top Categories Banners",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7491,
                  "level": 4,
                  "name": "عروض رمضان",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7501,
                  "level": 4,
                  "name": "عروض العيد",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7510,
                  "level": 3,
                  "name": "المكيفات",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7531,
                  "level": 2,
                  "name": "Test 10",
                  "is_parent": true
              },
              {
                  "is_virtual": true,
                  "code": "category",
                  "category_id": 7532,
                  "level": 3,
                  "name": "Test 11",
                  "is_parent": true
              }
          ],
          "catalog": [],
          "main_category": {
              "is_virtual": false,
              "code": "category",
              "category_id": 535,
              "level": 2,
              "name": "أجهزة التكييف",
              "is_parent": true
          }
      },
      "name": [
          "مكيف اوجنرال جدارى 24000 وحدة بارد ASSA24FUTA AOSA24FUTAH"
      ],
      "back_orders": 0,
      "sku": "2644128015",
      "stock": {
          "is_in_stock": true,
          "qty": 66
      },
      "rewrite_url": "o-general-split-ac-24000-btu-cold-only-assa24futa-aosa24futah-p-2644128015"
  },
  "highlight": {
      "name.standard": [
          "<strong>مكيف</strong> <strong>اوجنرال</strong> <strong>جدارى</strong> <strong>24000</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>ASSA24</strong><strong>FUTA</strong> <strong>AOSA24</strong><strong>FUTAH</strong>"
      ]
  },
  "sort": [
      -2147483648
  ]
},
{
  "_index": "almanea_ar_catalog_product_20240521_105952",
  "_id": "7865",
  "_score": null,
  "_source": {
      "1101": {
          "value": 41
      },
      "image": [
          "/f/5/f5d5aeb7-1bde-4248-ac5e-9a3952262167_1_1_1_1_1.jpg"
      ],
      "option_text_brand": [
          "اوجنرال"
      ],
      "prices_with_tax": {
          "discounted_price_to": "2024-04-10 11:30:07",
          "original_price": 5577.960001,
          "price": 5577.960001,
          "is_count_down": false,
          "discounted_price_from": "2024-04-08 11:30:07"
      },
      "type_id": "simple",
      "label": [],
      "entity_id": "7865",
      "eligible_for_tamara": [
          true
      ],
      "url_key": [
          "o-general-split-ac-19-600-btu-cold-only-assa18futa-aosa18futah-p-2644128010"
      ],
      "product_fees": [
          {
              "apply_per": "per_item",
              "description": "",
              "actions_serialized": "{\"type\":\"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\\\\Combine\",\"attribute\":null,\"operator\":null,\"value\":\"1\",\"is_value_processed\":null,\"aggregator\":\"all\",\"conditions\":[{\"type\":\"Magento\\\\SalesRule\\\\Model\\\\Rule\\\\Condition\\\\Product\",\"attribute\":\"sku\",\"operator\":\"()\",\"value\":\"2605426690,2605427310,2604730021,2605426689,2608181030,2608181050,2608815011,2608815040,2608815030,2608815020,2608815010,2644128021,2644128020,2644128011,2644128016,2644128015,2644128010,2619920105,2619920106,2619922008,2619922007,2619922002,2619922001,2622532024,2622531030,2622531020,2622531041,2622540005,2622560021,2608815021,2608815031,2608815050,2622531021,2644128025,2608814030,2608816010,2608816020,2608816021,2608816030,2608816031,2608816040,2608816050,2605427420,2605427430,2605427440,2605427450,2605427460,2608817020,2608817030,2608198021,2608198031,2608198041,2608816011,2619920211,2619920220,2619920221,2619920230,2619920231,2619920250,2619920260,2619920261,2622532121,2622532130,2622532140,2622532141,2622532150,2622532151,2622532120,2622531010,2622531011,2622532033,2608197041,2622532131,2644211010,2644211020,2644211030,2644211040\",\"is_value_processed\":false,\"attribute_scope\":\"\"}]}",
              "type": "4",
              "enable_customer_message": "0",
              "title": "4 M. Extension and Installation Service 230 SAR",
              "required": "0",
              "payment_methods": null,
              "options": {
                  "10": {
                      "is_free_for_some_cities": "0",
                      "field_label": "4 M. Extension and Installation Service-SAR 0.00",
                      "fee_option_id": "10",
                      "is_default": "0",
                      "title": "4 M. Extension and Installation Service",
                      "title_ar": "خدمة تركيب + خدمة تمديد 4 أمتار نحاس",
                      "price": "230.0000",
                      "fee_id": "5",
                      "price_type": "fixed",
                      "default_title": "4 M. Extension and Installation Service",
                      "field_label_ar": "خدمة تركيب + خدمة تمديد 4 أمتار نحاس-SAR 0.00",
                      "position": "2",
                      "store_default_title": "4 M. Extension and Installation Service",
                      "city_list": null
                  }
              },
              "date_field_title": "",
              "sku": "2689000003",
              "sort_order": "0",
              "store_code": "en",
              "store_id": [
                  "0"
              ],
              "_first_store_id": "2",
              "is_onetime": "0",
              "total_ordered": "24",
              "min_amount": "",
              "input_type": "radio",
              "applied_totals": "subtotal",
              "tax_class_id": "0",
              "conditions_serialized": "{\"type\":\"MageWorx\\\\MultiFees\\\\Model\\\\Fee\\\\Condition\\\\ProductFee\\\\Combine\",\"attribute\":null,\"operator\":null,\"value\":true,\"is_value_processed\":null,\"aggregator\":\"all\"}",
              "customer_message_title": "",
              "labels": {
                  "2": {
                      "description": "",
                      "date_field_title": "",
                      "title": "Added Services",
                      "customer_message_title": ""
                  },
                  "14": {
                      "description": "",
                      "date_field_title": "",
                      "title": "خدمات اضافيه",
                      "customer_message_title": ""
                  }
              },
              "total_base_amount": "5750.00",
              "shipping_methods": null,
              "count_percent_from": "product",
              "fee_id": "5",
              "use_bundle_qty": "1",
              "enable_date_field": "0",
              "unit_count": "1.0000",
              "status": "1"
          }
      ],
      "custom_related_products": [],
      "_media_": {
          "image": [
              {
                  "image": "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/f/5/f5d5aeb7-1bde-4248-ac5e-9a3952262167_1_1_1_1_1.webp",
                  "width": 800,
                  "position": "1",
                  "url": null,
                  "height": 600
              },
              {
                  "image": "https://store.dev-almanea.com/media/webps/jpg/media/catalog/product/a/s/assa18futaz.webp",
                  "width": 725,
                  "position": "2",
                  "url": null,
                  "height": 1200
              }
          ]
      },
      "eligible_for_tabby": [
          true
      ],
      "fast_delivery": [
          true
      ],
      "_category_": {
          "sub_categories": [
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 539,
                  "level": 3,
                  "name": "اسبليت",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7415,
                  "level": 2,
                  "name": "العروض",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7421,
                  "level": 2,
                  "name": "عروض العودة للمدارس",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7450,
                  "level": 2,
                  "name": "Almanea App",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7451,
                  "level": 3,
                  "name": "app slider",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7456,
                  "level": 4,
                  "name": "عروض رمضان",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7457,
                  "level": 3,
                  "name": "Recommended 3",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7460,
                  "level": 3,
                  "name": "Products Tab",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7461,
                  "level": 3,
                  "name": "Bannercenter2",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7468,
                  "level": 3,
                  "name": "categories home app",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7469,
                  "level": 4,
                  "name": "أجهزة التكييف",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7476,
                  "level": 3,
                  "name": "Categories Tabs",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7477,
                  "level": 3,
                  "name": "Top Categories hot",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7478,
                  "level": 3,
                  "name": "Top Categories Helpsi deals",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7479,
                  "level": 3,
                  "name": "Featured Categories new",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7480,
                  "level": 3,
                  "name": "Featured Categories hot",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7481,
                  "level": 3,
                  "name": "Featured Categories specal offer",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7483,
                  "level": 3,
                  "name": "Home Story",
                  "is_parent": false
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7484,
                  "level": 4,
                  "name": "Air Conditioners",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7490,
                  "level": 3,
                  "name": "Top Categories Banners",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7491,
                  "level": 4,
                  "name": "عروض رمضان",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7501,
                  "level": 4,
                  "name": "عروض العيد",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7510,
                  "level": 3,
                  "name": "المكيفات",
                  "is_parent": true
              },
              {
                  "is_virtual": false,
                  "code": "category",
                  "category_id": 7531,
                  "level": 2,
                  "name": "Test 10",
                  "is_parent": true
              },
              {
                  "is_virtual": true,
                  "code": "category",
                  "category_id": 7532,
                  "level": 3,
                  "name": "Test 11",
                  "is_parent": true
              }
          ],
          "catalog": [],
          "main_category": {
              "is_virtual": false,
              "code": "category",
              "category_id": 535,
              "level": 2,
              "name": "أجهزة التكييف",
              "is_parent": true
          }
      },
      "name": [
          "مكيف اوجنرال جدارى 19600 وحدة بارد ASSA18FUTA AOSA18FUTAH"
      ],
      "back_orders": 0,
      "sku": "2644128010",
      "stock": {
          "is_in_stock": true,
          "qty": 56
      },
      "rewrite_url": "o-general-split-ac-19-600-btu-cold-only-assa18futa-aosa18futah-p-2644128010"
  },
  "highlight": {
      "name.standard": [
          "<strong>مكيف</strong> <strong>اوجنرال</strong> <strong>جدارى</strong> <strong>19600</strong> <strong>وحدة</strong> <strong>بارد</strong> <strong>ASSA18</strong><strong>FUTA</strong> <strong>AOSA18</strong><strong>FUTAH</strong>"
      ]
  },
  "sort": [
      -2147483648
  ]
}
]
